import { PluginKey, TextSelection, NodeSelection, Plugin } from 'prosemirror-state';
import { NodeExtension } from '../../../core/index.js';
import 'prosemirror-model';
import { DecorationSet, Decoration } from 'prosemirror-view';
import 'prosemirror-inputrules';
import 'prosemirror-commands';
import { v4 } from 'uuid';
import { createInstance } from '@sailor/i18n-web';
import React, { useState, useCallback, useRef, useEffect, useMemo, Component, Fragment } from 'react';
import ReactDOM, { render } from 'react-dom';
import classNames from 'classnames';

/**
 * Enter 键的 keycode
 */ var KEY_CODE_ENTER = 13;
/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";
/**
 * 零宽度空格
 */ var ZERO_WIDTH_SPACE = "​";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var optionsMerge = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var res = _objectSpread({}, target, source);
    if (source.state) {
        res.state = optionsMerge(target.state, source.state);
    }
    if (source.props) {
        res.props = optionsMerge(target.props, source.props);
    }
    return res;
};
function UploaderOption(pluginOption, param) {
    var createUploadMask = param.createUploadMask;
    var uploaderOption = {
        state: {
            init: function init() {
                return DecorationSet.empty;
            },
            apply: function apply(tr, set) {
                // Adjust decoration positions to changes made by the transaction
                set = set.map(tr.mapping, tr.doc);
                // See if the transaction adds or removes any placeholders
                var action = tr.getMeta(this);
                if (action && action.add) {
                    var widget = createUploadMask(action.add, action.add.id);
                    var deco = Decoration.widget(action.add.pos, widget, {
                        id: action.add.id,
                        ignoreSelection: true
                    });
                    set = set.add(tr.doc, [
                        deco
                    ]);
                } else if (action && action.remove) {
                    set = set.remove(set.find(null, null, function(spec) {
                        return spec.id === action.remove.id;
                    }));
                }
                return set;
            }
        },
        props: {
            decorations: function decorations(state) {
                return this.getState(state);
            }
        }
    };
    return optionsMerge(pluginOption, uploaderOption);
}

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
// 向上寻找指定DOM节点
var findParentDOM = function(targetDOM, assert) {
    var dom = targetDOM;
    while(true){
        if (!dom || dom.classList && dom.classList.contains("ProseMirror")) {
            return false;
        }
        if (assert(dom)) return dom;
        dom = dom.parentNode;
    }
};
var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};
/*
 * 更新指定位置的节点属性
 * @param type 节点类型
 * @param data 属性数据
 * @param pos 节点位置
 * @param view EditorView 实例
 */ var updateNodeAttrs = function(param) {
    var type = param.type, data = param.data, pos = param.pos, view = param.view;
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr;
    var ctrlNode = tr.doc.nodeAt(pos);
    if (!ctrlNode) {
        return;
    }
    var attrs = _objectSpread$1({}, ctrlNode.attrs, data);
    tr.setNodeMarkup(pos, type, attrs);
    dispatch(tr);
};

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");
/**
 * 图片最小尺寸限制
 */ var MIN_IMG_SIZE = 20;
/**
 * 图片展示默认大小
 */ var IMAGE_DEFAULT_WIDTH = 100;
var IMAGE_DEFAULT_MAX_WIDTH = 1000;
var IMAGE_DEFAULT_HEIGHT = 100;
// margin(4) && border(2)
var IMAGE_OFFSET = 4;

var TABLE_HEIGHT_CHANGE = "table_height_change";

var IMAGE_MAX_HEIGHT = 600;
var isCommonDisabled = function() {
    return function(state) {
        return !canInsertTypes(state);
    };
};
/**
 * 计算规则，需要按顺序满足下面两项
 * 1. 高度不能高于 imageMaxHeight
 * 2. 宽度不能大于容器宽度
 */ function calculateSize(originWidth, originHeight, containerWidth) {
    var imageMaxHeight = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : IMAGE_MAX_HEIGHT;
    var result = {
        newOriginHeight: 0,
        newOriginWidth: 0,
        height: 0,
        width: 0
    };
    if (originHeight <= imageMaxHeight) {
        result.newOriginWidth = originWidth;
        result.newOriginHeight = originHeight;
        if (originWidth > containerWidth) {
            result.width = containerWidth;
            result.height = +(originHeight * containerWidth / originWidth).toFixed(2);
        } else {
            result.width = originWidth;
            result.height = originHeight;
        }
    } else {
        result.width = +(originWidth * imageMaxHeight / originHeight).toFixed(2);
        result.height = imageMaxHeight;
        result.newOriginWidth = result.width;
        result.newOriginHeight = imageMaxHeight;
        if (result.width > containerWidth) {
            result.width = containerWidth;
            // result.height = +(imageMaxHeight * containerWidth / result.width).toFixed(2);
            result.height = +(containerWidth / originWidth * originHeight).toFixed(2);
        }
    }
    return result;
}
/**
 * 处理例如图片加载完成导致的表格高度改变,用于表格侧边选择条高度更新
 * 详见https://ones.sankuai.com/ones/product/1859/workItem/task/detail/21026880
 * @param containerWrapper 图片类容器节点
 */ var emitTableHeightChange = function(containerWrapper, eventEmitter) {
    var parentTable = findParentDOM(containerWrapper, function(n) {
        return n.tagName.toUpperCase() === "TABLE";
    });
    if (parentTable) {
        eventEmitter.emit(TABLE_HEIGHT_CHANGE);
    }
};

var IMAGE_BORDER_KEY = "IMAGE_BORDER_KEY";

var locale = "en";
var version = 16;
var cannot_search_user = "User not found, click space to complete input";
var load_fail_retry = "Failed to load, please try again later";
var pk_avatar = "avatar";
var mention_by_mis_name = "Can @user by name and MIS number";
var searching = "Searching...";
var pk_link_text = "Text";
var insert_blank = "Insert";
var pk_visit_link = "Access the link";
var pk_link_address = "Address";
var pk_link = "Link";
var cancel_blank = "Cancel";
var pk_link_change_tip = "Link text follows the Doc change";
var pk_edit_link = "Edit link";
var pk_link_text_tip = "Input the link text";
var pk_cancel_link = "Cancel link";
var save_blank = "Save";
var pk_link_address_tip = "Input the link address";
var border = "Border";
var pk_insert = "Insert";
var image_link = "Image Link";
var pk_retry = "Retry";
var pk_edit = "Edit";
var width = "Width";
var reupload = "Reupload";
var image_upload_fail1 = "Sorry, upload error!";
var right_address_tip = "Please input right address";
var image_upload_fail3 = "Otherwise, please click button below to retry.";
var image_upload_fail2 = "If the image is moved/pasted from outside, please download and reupload.";
var pk_confirm = "Confirm";
var input_html = "Enter HTML code.";
var formual = "Formual";
var pk_loading = "Loading...";
var click_to_expand = "Click to expand the content";
var pk_cancel = "Cancel";
var input_html_tip = "You can insert HTML code to embed corresponding content on a webpage.";
var input_latex = "Enter Latex code";
var insert_latex_tip = "You can insert Latex code to embed corresponding content within the page.";
var pk_title = "Title";
var wire_frame = "Wireframe";
var fill_in = "Fill";
var input_plantuml = "Enter PlantUML code.";
var border_style = "Border type";
var set_th_line = "Header Column";
var set_th_row = "Header Row";
var table_attr = "Table style";
var cancel_th_line = "Cancel Header Column";
var insert_line_right = "Right Insert Column";
var insert_row = "Delete Rows";
var split_cell = "Split cells";
var delete_line = "Delete Columns";
var pk_no = "No borders";
var input_markdown_tip = "You can insert Markdown code to embed corresponding content within the page.";
var confirm_blank = "Confirm";
var cancel_th_row = "Cancel Header Row";
var insert_row_above = "Insert Row Above";
var delete_table = "Delete";
var input_plantuml_tip = "You can insert PlantUML code to embed corresponding content within the page.";
var border_width = "Border width";
var input_markdown = "Enter Markdown code.";
var merge_cell = "Merge cells";
var set_line_num = "Show Row Number";
var border_color = "Border color";
var insert_line_left = "Left Insert Column";
var insert_row_below = "Insert Row Below";
var cancel_line_num = "Cancel Row Number";
var exit_data_lost_tip = "If you exit, any unsaved data will be lost.";
var if_exit_gantt = "Are you sure to exit the Gantt chart?";
var pk_gantt_loading = "Loading Gantt chart...";
var gantt_load_fail = "Gantt chart loading failed.";
var operate_error = "Invalid operation";
var gantt_keep_work_tip = "Please keep at least one task.";
var save_success = "Save successful";
var gantt_frame_load_fail = "Gantt chart framework failed to load.";
var pk_network_exception = "Network exception";
var save_fail = "Save failed";
var pk_saving = "Saving...";
var gantt_plugin_fail = "Gantt chart editing plugin failed to start.";
var gantt_editing_tip = "Editing Gantt Chart, please wait a moment.";
var pk_discard = "Drop";
var pk_zoom_in = "Zoom in";
var pk_zoom_out = "Zoom out";
var pk_use = "Use";
var draft_edit_tip = "There is a draft that was edited but not saved on {time}. Do you want to continue editing?";
var if_use_local_draft = "Do you use local drafts?";
var pk_load_fail = "Loading failed";
var pk_this_time = "Now";
var choose_time = "Select time";
var pk_hh_mm_ss = "hh:mm:ss A";
var pk_y_d = "MM-DD-YYYY";
var pk_y_d_ts = "MM-DD-YYYY hh:mm:ss A";
var pk_text = "Text";
var h1 = "Heading 1";
var h2 = "Heading 2";
var h3 = "Heading 3";
var h4 = "Heading 4";
var h5 = "Heading 5";
var h6 = "Heading 6";
var pk_catalog = "Catalog";
var page_view_load_fail_click = "Directory tree loading failed. Please click to reload.";
var page_tree_no_sub_doc = "No sub documents found in this directory";
var page_tree_no_perm = "No permission to view the directory tree.";
var pk_load_fail_retry = "Loading failed, please click to reload.";
var loading2 = "Loading";
var page_tree_deleted = "The directory tree has been deleted.";
var pk_pause = "Pause";
var pk_mute = "Mute";
var pk_untitled = "Untitled";
var pk_play = "Play";
var adjust_volume = "Adjust volume";
var download_fail_retry = "Download failed please retry";
var pk_download = "Download";
var get_file_fail = "Failed to get file";
var pk_network_fail = "Network connection failed";
var pk_upload_fail = "Upload failed";
var audio_not_support_tip = "This browser does not support the HTML5 audio tag.";
var pk_volume = "Volume";
var browser_not_support_tip = "This browser does not support the HTML5 video tag.";
var pk_zoom_in2 = "Zoom in";
var video_upload_tip = "Video is being transcoded, if the file is large, it may take a long time. Please wait patiently...";
var pk_video = "Video";
var pk_zoom_out2 = "Zoom out";
var space_update_fail_tip = "Space update acquisition failed. Click to retry.";
var pk_recent_update = "Recent Updates";
var show_more = "Show More";
var no_space_update = "No Updates in Space.";
var pk_restore = "Restore";
var en_parker = {
    locale: locale,
    version: version,
    cannot_search_user: cannot_search_user,
    load_fail_retry: load_fail_retry,
    pk_avatar: pk_avatar,
    mention_by_mis_name: mention_by_mis_name,
    searching: searching,
    pk_link_text: pk_link_text,
    insert_blank: insert_blank,
    pk_visit_link: pk_visit_link,
    pk_link_address: pk_link_address,
    pk_link: pk_link,
    cancel_blank: cancel_blank,
    pk_link_change_tip: pk_link_change_tip,
    pk_edit_link: pk_edit_link,
    pk_link_text_tip: pk_link_text_tip,
    pk_cancel_link: pk_cancel_link,
    save_blank: save_blank,
    pk_link_address_tip: pk_link_address_tip,
    border: border,
    pk_insert: pk_insert,
    image_link: image_link,
    pk_retry: pk_retry,
    pk_edit: pk_edit,
    width: width,
    reupload: reupload,
    image_upload_fail1: image_upload_fail1,
    right_address_tip: right_address_tip,
    image_upload_fail3: image_upload_fail3,
    image_upload_fail2: image_upload_fail2,
    pk_confirm: pk_confirm,
    input_html: input_html,
    formual: formual,
    pk_loading: pk_loading,
    click_to_expand: click_to_expand,
    pk_cancel: pk_cancel,
    input_html_tip: input_html_tip,
    input_latex: input_latex,
    insert_latex_tip: insert_latex_tip,
    pk_title: pk_title,
    wire_frame: wire_frame,
    fill_in: fill_in,
    input_plantuml: input_plantuml,
    border_style: border_style,
    set_th_line: set_th_line,
    set_th_row: set_th_row,
    table_attr: table_attr,
    cancel_th_line: cancel_th_line,
    insert_line_right: insert_line_right,
    insert_row: insert_row,
    split_cell: split_cell,
    delete_line: delete_line,
    pk_no: pk_no,
    input_markdown_tip: input_markdown_tip,
    confirm_blank: confirm_blank,
    cancel_th_row: cancel_th_row,
    insert_row_above: insert_row_above,
    delete_table: delete_table,
    input_plantuml_tip: input_plantuml_tip,
    border_width: border_width,
    input_markdown: input_markdown,
    merge_cell: merge_cell,
    set_line_num: set_line_num,
    border_color: border_color,
    insert_line_left: insert_line_left,
    insert_row_below: insert_row_below,
    cancel_line_num: cancel_line_num,
    exit_data_lost_tip: exit_data_lost_tip,
    if_exit_gantt: if_exit_gantt,
    pk_gantt_loading: pk_gantt_loading,
    gantt_load_fail: gantt_load_fail,
    operate_error: operate_error,
    gantt_keep_work_tip: gantt_keep_work_tip,
    save_success: save_success,
    gantt_frame_load_fail: gantt_frame_load_fail,
    pk_network_exception: pk_network_exception,
    save_fail: save_fail,
    pk_saving: pk_saving,
    gantt_plugin_fail: gantt_plugin_fail,
    gantt_editing_tip: gantt_editing_tip,
    pk_discard: pk_discard,
    pk_zoom_in: pk_zoom_in,
    pk_zoom_out: pk_zoom_out,
    pk_use: pk_use,
    draft_edit_tip: draft_edit_tip,
    if_use_local_draft: if_use_local_draft,
    pk_load_fail: pk_load_fail,
    pk_this_time: pk_this_time,
    choose_time: choose_time,
    pk_hh_mm_ss: pk_hh_mm_ss,
    pk_y_d: pk_y_d,
    pk_y_d_ts: pk_y_d_ts,
    pk_text: pk_text,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    pk_catalog: pk_catalog,
    page_view_load_fail_click: page_view_load_fail_click,
    page_tree_no_sub_doc: page_tree_no_sub_doc,
    page_tree_no_perm: page_tree_no_perm,
    pk_load_fail_retry: pk_load_fail_retry,
    loading2: loading2,
    page_tree_deleted: page_tree_deleted,
    pk_pause: pk_pause,
    pk_mute: pk_mute,
    pk_untitled: pk_untitled,
    pk_play: pk_play,
    adjust_volume: adjust_volume,
    download_fail_retry: download_fail_retry,
    pk_download: pk_download,
    get_file_fail: get_file_fail,
    pk_network_fail: pk_network_fail,
    pk_upload_fail: pk_upload_fail,
    audio_not_support_tip: audio_not_support_tip,
    pk_volume: pk_volume,
    browser_not_support_tip: browser_not_support_tip,
    pk_zoom_in2: pk_zoom_in2,
    video_upload_tip: video_upload_tip,
    pk_video: pk_video,
    pk_zoom_out2: pk_zoom_out2,
    space_update_fail_tip: space_update_fail_tip,
    pk_recent_update: pk_recent_update,
    show_more: show_more,
    no_space_update: no_space_update,
    pk_restore: pk_restore
};

var locale$1 = "zh";
var version$1 = 16;
var cannot_search_user$1 = "未搜索到用户，点击空格完成输入";
var load_fail_retry$1 = "加载失败，请稍后重试";
var pk_avatar$1 = "头像";
var mention_by_mis_name$1 = "可通过姓名及mis号@用户";
var searching$1 = "搜索中...";
var pk_link_text$1 = "链接文字";
var insert_blank$1 = "插 入";
var pk_link$1 = "链接";
var pk_link_address$1 = "链接地址";
var pk_visit_link$1 = "访问链接";
var cancel_blank$1 = "取 消";
var pk_link_change_tip$1 = "链接文字跟随文档标题变更";
var pk_edit_link$1 = "编辑链接";
var pk_cancel_link$1 = "取消链接";
var pk_link_text_tip$1 = "请输入链接文字";
var save_blank$1 = "保 存";
var pk_link_address_tip$1 = "请输入链接地址";
var border$1 = "边框";
var pk_insert$1 = "插入";
var image_link$1 = "图片链接";
var pk_edit$1 = "编辑";
var pk_retry$1 = "重试";
var width$1 = "宽度";
var reupload$1 = "重新上传";
var image_upload_fail1$1 = "抱歉，图片上传失败！";
var image_upload_fail3$1 = "否则，请点击下方按钮进行重试。";
var right_address_tip$1 = "请输入正确的地址";
var image_upload_fail2$1 = "如果是从外部拖动、粘贴过来的图片，请下载原图并重新上传。";
var pk_confirm$1 = "确定";
var input_html$1 = "输入HTML代码";
var formual$1 = "公式";
var pk_loading$1 = "正在加载中...";
var pk_cancel$1 = "取消";
var click_to_expand$1 = "点击展开内容";
var input_html_tip$1 = "可以插入HTML代码，以在页面内嵌入相应内容：";
var insert_latex_tip$1 = "可以插入Latex代码，以在页面内嵌入相应内容：";
var input_latex$1 = "输入Latex代码";
var pk_title$1 = "标题";
var wire_frame$1 = "线框";
var fill_in$1 = "填充";
var input_plantuml$1 = "輸入PlantUML代碼";
var border_style$1 = "边框样式";
var set_th_row$1 = "设置表头行";
var set_th_line$1 = "设置表头列";
var table_attr$1 = "表格属性";
var cancel_th_line$1 = "取消表头列";
var insert_row$1 = "删除行";
var insert_line_right$1 = "右侧插入列";
var split_cell$1 = "拆分单元格";
var delete_line$1 = "删除列";
var confirm_blank$1 = "确 定";
var input_markdown_tip$1 = "可以插入Markdown代码，以在页面内嵌入相应内容：";
var pk_no$1 = "无";
var cancel_th_row$1 = "取消表头行";
var insert_row_above$1 = "上方插入行";
var delete_table$1 = "删除表格";
var input_plantuml_tip$1 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容";
var border_width$1 = "边框宽度";
var input_markdown$1 = "输入Markdown代码";
var merge_cell$1 = "合并单元格";
var set_line_num$1 = "设置行号列";
var border_color$1 = "边框颜色";
var insert_line_left$1 = "左侧插入列";
var insert_row_below$1 = "下方插入行";
var cancel_line_num$1 = "取消行号列";
var if_exit_gantt$1 = "确定退出甘特图?";
var exit_data_lost_tip$1 = "退出后，尚未保存的数据将丢失。";
var gantt_load_fail$1 = "甘特图载入失败";
var pk_gantt_loading$1 = "甘特图载入中...";
var operate_error$1 = "您的操作有误";
var gantt_keep_work_tip$1 = "请至少保留一个任务";
var gantt_frame_load_fail$1 = "甘特图框架加载失败";
var save_success$1 = "保存成功";
var save_fail$1 = "保存失败";
var pk_network_exception$1 = "网络异常";
var pk_saving$1 = "正在保存中...";
var gantt_plugin_fail$1 = "甘特图编辑插件启动失败";
var gantt_editing_tip$1 = "正在编辑甘特图，请稍候再试噢。";
var pk_discard$1 = "废弃";
var pk_zoom_in$1 = "放大查看";
var pk_zoom_out$1 = "缩小查看";
var pk_use$1 = "使用";
var draft_edit_tip$1 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继续编辑";
var pk_load_fail$1 = "加载失败";
var if_use_local_draft$1 = "是否使用本地草稿？";
var pk_this_time$1 = "此刻";
var choose_time$1 = "选择时间";
var pk_hh_mm_ss$1 = "HH:mm:ss";
var pk_y_d$1 = "YYYY-MM-DD";
var pk_y_d_ts$1 = "YYYY-MM-DD HH:mm:ss";
var pk_text$1 = "正文";
var h1$1 = "标题 1";
var h2$1 = "标题 2";
var h3$1 = "标题 3";
var h4$1 = "标题 4";
var h5$1 = "标题 5";
var h6$1 = "标题 6";
var pk_catalog$1 = "目录";
var page_view_load_fail_click$1 = "目录树加载失败，请点击重新加载";
var page_tree_no_sub_doc$1 = "该目录下暂无子文档";
var page_tree_no_perm$1 = "无权查看该目录树";
var pk_load_fail_retry$1 = "加载失败，请点击重新加载";
var loading2$1 = "正在加载";
var page_tree_deleted$1 = "该目录树已被删除";
var pk_pause$1 = "暂停";
var pk_mute$1 = "静音";
var pk_untitled$1 = "未命名";
var pk_play$1 = "播放";
var adjust_volume$1 = "音量调节";
var download_fail_retry$1 = "下载失败，请重试";
var get_file_fail$1 = "文件获取失败";
var pk_download$1 = "下载";
var pk_network_fail$1 = "网络连接失败";
var pk_upload_fail$1 = "上传失败";
var audio_not_support_tip$1 = "本浏览器不支持 HTML5 audio 标签";
var browser_not_support_tip$1 = "本浏览器不支持 HTML5 video 标签";
var pk_volume$1 = "音量";
var pk_zoom_in2$1 = "放大";
var pk_video$1 = "视频";
var video_upload_tip$1 = "视频正在转码中，如文件较大可能时间较长，请耐心等待…";
var pk_zoom_out2$1 = "缩小";
var space_update_fail_tip$1 = "空间更新获取失败，点击重试";
var pk_recent_update$1 = "最近更新";
var show_more$1 = "显示更多";
var no_space_update$1 = "空间暂时没有动态～";
var pk_restore$1 = "恢复默认";
var zh_parker = {
    locale: locale$1,
    version: version$1,
    cannot_search_user: cannot_search_user$1,
    load_fail_retry: load_fail_retry$1,
    pk_avatar: pk_avatar$1,
    mention_by_mis_name: mention_by_mis_name$1,
    searching: searching$1,
    pk_link_text: pk_link_text$1,
    insert_blank: insert_blank$1,
    pk_link: pk_link$1,
    pk_link_address: pk_link_address$1,
    pk_visit_link: pk_visit_link$1,
    cancel_blank: cancel_blank$1,
    pk_link_change_tip: pk_link_change_tip$1,
    pk_edit_link: pk_edit_link$1,
    pk_cancel_link: pk_cancel_link$1,
    pk_link_text_tip: pk_link_text_tip$1,
    save_blank: save_blank$1,
    pk_link_address_tip: pk_link_address_tip$1,
    border: border$1,
    pk_insert: pk_insert$1,
    image_link: image_link$1,
    pk_edit: pk_edit$1,
    pk_retry: pk_retry$1,
    width: width$1,
    reupload: reupload$1,
    image_upload_fail1: image_upload_fail1$1,
    image_upload_fail3: image_upload_fail3$1,
    right_address_tip: right_address_tip$1,
    image_upload_fail2: image_upload_fail2$1,
    pk_confirm: pk_confirm$1,
    input_html: input_html$1,
    formual: formual$1,
    pk_loading: pk_loading$1,
    pk_cancel: pk_cancel$1,
    click_to_expand: click_to_expand$1,
    input_html_tip: input_html_tip$1,
    insert_latex_tip: insert_latex_tip$1,
    input_latex: input_latex$1,
    pk_title: pk_title$1,
    wire_frame: wire_frame$1,
    fill_in: fill_in$1,
    input_plantuml: input_plantuml$1,
    border_style: border_style$1,
    set_th_row: set_th_row$1,
    set_th_line: set_th_line$1,
    table_attr: table_attr$1,
    cancel_th_line: cancel_th_line$1,
    insert_row: insert_row$1,
    insert_line_right: insert_line_right$1,
    split_cell: split_cell$1,
    delete_line: delete_line$1,
    confirm_blank: confirm_blank$1,
    input_markdown_tip: input_markdown_tip$1,
    pk_no: pk_no$1,
    cancel_th_row: cancel_th_row$1,
    insert_row_above: insert_row_above$1,
    delete_table: delete_table$1,
    input_plantuml_tip: input_plantuml_tip$1,
    border_width: border_width$1,
    input_markdown: input_markdown$1,
    merge_cell: merge_cell$1,
    set_line_num: set_line_num$1,
    border_color: border_color$1,
    insert_line_left: insert_line_left$1,
    insert_row_below: insert_row_below$1,
    cancel_line_num: cancel_line_num$1,
    if_exit_gantt: if_exit_gantt$1,
    exit_data_lost_tip: exit_data_lost_tip$1,
    gantt_load_fail: gantt_load_fail$1,
    pk_gantt_loading: pk_gantt_loading$1,
    operate_error: operate_error$1,
    gantt_keep_work_tip: gantt_keep_work_tip$1,
    gantt_frame_load_fail: gantt_frame_load_fail$1,
    save_success: save_success$1,
    save_fail: save_fail$1,
    pk_network_exception: pk_network_exception$1,
    pk_saving: pk_saving$1,
    gantt_plugin_fail: gantt_plugin_fail$1,
    gantt_editing_tip: gantt_editing_tip$1,
    pk_discard: pk_discard$1,
    pk_zoom_in: pk_zoom_in$1,
    pk_zoom_out: pk_zoom_out$1,
    pk_use: pk_use$1,
    draft_edit_tip: draft_edit_tip$1,
    pk_load_fail: pk_load_fail$1,
    if_use_local_draft: if_use_local_draft$1,
    pk_this_time: pk_this_time$1,
    choose_time: choose_time$1,
    pk_hh_mm_ss: pk_hh_mm_ss$1,
    pk_y_d: pk_y_d$1,
    pk_y_d_ts: pk_y_d_ts$1,
    pk_text: pk_text$1,
    h1: h1$1,
    h2: h2$1,
    h3: h3$1,
    h4: h4$1,
    h5: h5$1,
    h6: h6$1,
    pk_catalog: pk_catalog$1,
    page_view_load_fail_click: page_view_load_fail_click$1,
    page_tree_no_sub_doc: page_tree_no_sub_doc$1,
    page_tree_no_perm: page_tree_no_perm$1,
    pk_load_fail_retry: pk_load_fail_retry$1,
    loading2: loading2$1,
    page_tree_deleted: page_tree_deleted$1,
    pk_pause: pk_pause$1,
    pk_mute: pk_mute$1,
    pk_untitled: pk_untitled$1,
    pk_play: pk_play$1,
    adjust_volume: adjust_volume$1,
    download_fail_retry: download_fail_retry$1,
    get_file_fail: get_file_fail$1,
    pk_download: pk_download$1,
    pk_network_fail: pk_network_fail$1,
    pk_upload_fail: pk_upload_fail$1,
    audio_not_support_tip: audio_not_support_tip$1,
    browser_not_support_tip: browser_not_support_tip$1,
    pk_volume: pk_volume$1,
    pk_zoom_in2: pk_zoom_in2$1,
    pk_video: pk_video$1,
    video_upload_tip: video_upload_tip$1,
    pk_zoom_out2: pk_zoom_out2$1,
    space_update_fail_tip: space_update_fail_tip$1,
    pk_recent_update: pk_recent_update$1,
    show_more: show_more$1,
    no_space_update: no_space_update$1,
    pk_restore: pk_restore$1
};

var locale$2 = "zh-HK";
var version$2 = 16;
var cannot_search_user$2 = "未能找到用户，請按空格鍵完成輸入";
var load_fail_retry$2 = "載入失敗，請稍後重試。";
var pk_avatar$2 = "頭像";
var mention_by_mis_name$2 = "可通過姓名及MIS號碼@用戶";
var searching$2 = "搜尋中...";
var pk_link_text$2 = "鏈接文字";
var insert_blank$2 = "插 入";
var pk_visit_link$2 = "访问鏈接";
var pk_link_address$2 = "鏈接地址";
var pk_link$2 = "鏈接";
var cancel_blank$2 = "取 消";
var pk_link_change_tip$2 = "鏈接文字跟隨文件標題變更";
var pk_edit_link$2 = "編輯鏈接";
var pk_link_text_tip$2 = "請輸入鏈接文字";
var pk_cancel_link$2 = "取消鏈接";
var save_blank$2 = "保 存";
var pk_link_address_tip$2 = "請輸入鏈接地址";
var border$2 = "邊框";
var pk_insert$2 = "插入";
var image_link$2 = "圖片鏈接";
var pk_retry$2 = "重試";
var pk_edit$2 = "編輯";
var width$2 = "寬度";
var reupload$2 = "重新上傳";
var image_upload_fail1$2 = "抱歉，圖片上傳失敗！";
var right_address_tip$2 = "請輸入正確的地址";
var image_upload_fail3$2 = "否則，請按下方按鈕進行重試。";
var image_upload_fail2$2 = "如果您從外部拖動、粘貼過來的圖片，請下載原圖並重新上傳。";
var pk_confirm$2 = "確定";
var input_html$2 = "輸入HTML代碼";
var formual$2 = "公式";
var pk_loading$2 = "正在載入中...";
var pk_cancel$2 = "取消";
var click_to_expand$2 = "點選展開內容";
var input_html_tip$2 = "可以插入HTML代碼，以在頁面內嵌入相應內容：";
var insert_latex_tip$2 = "可以插入Latex代碼，以在頁面內嵌入相應內容：";
var input_latex$2 = "输入LaTeX代码";
var pk_title$2 = "標題";
var wire_frame$2 = "線框";
var fill_in$2 = "填充";
var input_plantuml$2 = "輸入PlantUML程式碼";
var border_style$2 = "邊框樣式";
var set_th_row$2 = "設置表頭行";
var set_th_line$2 = "設置表頭列";
var table_attr$2 = "表格屬性";
var cancel_th_line$2 = "取消表頭列";
var insert_row$2 = "删除行";
var insert_line_right$2 = "右側插入列";
var split_cell$2 = "拆分儲存格";
var delete_line$2 = "删除列";
var pk_no$2 = "無";
var confirm_blank$2 = "確 定";
var input_markdown_tip$2 = "可以插入Markdown代碼，以在頁面內嵌入相應內容：";
var cancel_th_row$2 = "取消表頭行";
var insert_row_above$2 = "上方插入行";
var delete_table$2 = "刪除表格";
var input_plantuml_tip$2 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容：";
var border_width$2 = "邊框寬度";
var input_markdown$2 = "輸入Markdown代碼";
var merge_cell$2 = "合併儲存格";
var set_line_num$2 = "設置行号列";
var border_color$2 = "邊框顏色";
var insert_line_left$2 = "左側插入列";
var insert_row_below$2 = "下方插入行";
var cancel_line_num$2 = "取消行号列";
var if_exit_gantt$2 = "確定退出甘特圖?";
var exit_data_lost_tip$2 = "退出後，尚未儲存的數據將會遺失。";
var pk_gantt_loading$2 = "甘特圖載入中...";
var gantt_load_fail$2 = "甘特圖載入失敗";
var operate_error$2 = "您的操作有誤";
var gantt_keep_work_tip$2 = "請至少保留一個任務";
var save_success$2 = "保存成功";
var gantt_frame_load_fail$2 = "甘特圖框架載入失敗";
var save_fail$2 = "保存失敗";
var pk_network_exception$2 = "網絡異常";
var pk_saving$2 = "正在儲存中...";
var gantt_plugin_fail$2 = "甘特圖編輯插件啟動失敗。";
var gantt_editing_tip$2 = "正在編輯甘特圖，請稍後再試唷。";
var pk_discard$2 = "廢棄";
var pk_zoom_in$2 = "放大查看";
var pk_zoom_out$2 = "縮小查看";
var pk_use$2 = "使用";
var draft_edit_tip$2 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继續編輯";
var pk_load_fail$2 = "加載失敗";
var if_use_local_draft$2 = "是否使用本地草稿？";
var pk_this_time$2 = "此刻";
var choose_time$2 = "選擇時間";
var pk_hh_mm_ss$2 = "HH:mm:ss";
var pk_y_d$2 = "YYYY-MM-DD";
var pk_y_d_ts$2 = "YYYY-MM-DD HH:mm:ss";
var pk_text$2 = "正文";
var h1$2 = "標題 1";
var h2$2 = "標題 2";
var h3$2 = "標題 3";
var h4$2 = "標題 4";
var h5$2 = "標題 5";
var h6$2 = "標題 6";
var pk_catalog$2 = "目錄";
var page_view_load_fail_click$2 = "目錄樹加載失敗，請點擊重新加載。";
var page_tree_no_sub_doc$2 = "該目錄下暫無子文檔。";
var page_tree_no_perm$2 = "無權查看該目錄樹";
var pk_load_fail_retry$2 = "加載失敗，請點擊重新加載。";
var loading2$2 = "正在載入";
var page_tree_deleted$2 = "該目錄樹已被刪除";
var pk_pause$2 = "暫停";
var pk_mute$2 = "靜音";
var pk_untitled$2 = "未命名";
var pk_play$2 = "播放";
var adjust_volume$2 = "音量調節";
var download_fail_retry$2 = "下載失敗，請重試";
var pk_download$2 = "下載";
var get_file_fail$2 = "文件獲取失敗";
var pk_network_fail$2 = "網絡連接失敗";
var pk_upload_fail$2 = "上載失敗";
var audio_not_support_tip$2 = "本瀏覽器不支援 HTML5 audio 標籤";
var pk_volume$2 = "音量";
var browser_not_support_tip$2 = "本瀏覽器不支援 HTML5 video 標籤";
var pk_zoom_in2$2 = "放大";
var video_upload_tip$2 = "視頻正在轉碼中，如果文件較大可能需要較長的時間，請耐心等待...";
var pk_video$2 = "視頻";
var pk_zoom_out2$2 = "縮小";
var space_update_fail_tip$2 = "空間更新獲取失敗，點擊重試";
var pk_recent_update$2 = "最近更新";
var show_more$2 = "顯示更多";
var no_space_update$2 = "空間暫時沒有動態～";
var pk_restore$2 = "恢復預設";
var zhHK_parker = {
    locale: locale$2,
    version: version$2,
    cannot_search_user: cannot_search_user$2,
    load_fail_retry: load_fail_retry$2,
    pk_avatar: pk_avatar$2,
    mention_by_mis_name: mention_by_mis_name$2,
    searching: searching$2,
    pk_link_text: pk_link_text$2,
    insert_blank: insert_blank$2,
    pk_visit_link: pk_visit_link$2,
    pk_link_address: pk_link_address$2,
    pk_link: pk_link$2,
    cancel_blank: cancel_blank$2,
    pk_link_change_tip: pk_link_change_tip$2,
    pk_edit_link: pk_edit_link$2,
    pk_link_text_tip: pk_link_text_tip$2,
    pk_cancel_link: pk_cancel_link$2,
    save_blank: save_blank$2,
    pk_link_address_tip: pk_link_address_tip$2,
    border: border$2,
    pk_insert: pk_insert$2,
    image_link: image_link$2,
    pk_retry: pk_retry$2,
    pk_edit: pk_edit$2,
    width: width$2,
    reupload: reupload$2,
    image_upload_fail1: image_upload_fail1$2,
    right_address_tip: right_address_tip$2,
    image_upload_fail3: image_upload_fail3$2,
    image_upload_fail2: image_upload_fail2$2,
    pk_confirm: pk_confirm$2,
    input_html: input_html$2,
    formual: formual$2,
    pk_loading: pk_loading$2,
    pk_cancel: pk_cancel$2,
    click_to_expand: click_to_expand$2,
    input_html_tip: input_html_tip$2,
    insert_latex_tip: insert_latex_tip$2,
    input_latex: input_latex$2,
    pk_title: pk_title$2,
    wire_frame: wire_frame$2,
    fill_in: fill_in$2,
    input_plantuml: input_plantuml$2,
    border_style: border_style$2,
    set_th_row: set_th_row$2,
    set_th_line: set_th_line$2,
    table_attr: table_attr$2,
    cancel_th_line: cancel_th_line$2,
    insert_row: insert_row$2,
    insert_line_right: insert_line_right$2,
    split_cell: split_cell$2,
    delete_line: delete_line$2,
    pk_no: pk_no$2,
    confirm_blank: confirm_blank$2,
    input_markdown_tip: input_markdown_tip$2,
    cancel_th_row: cancel_th_row$2,
    insert_row_above: insert_row_above$2,
    delete_table: delete_table$2,
    input_plantuml_tip: input_plantuml_tip$2,
    border_width: border_width$2,
    input_markdown: input_markdown$2,
    merge_cell: merge_cell$2,
    set_line_num: set_line_num$2,
    border_color: border_color$2,
    insert_line_left: insert_line_left$2,
    insert_row_below: insert_row_below$2,
    cancel_line_num: cancel_line_num$2,
    if_exit_gantt: if_exit_gantt$2,
    exit_data_lost_tip: exit_data_lost_tip$2,
    pk_gantt_loading: pk_gantt_loading$2,
    gantt_load_fail: gantt_load_fail$2,
    operate_error: operate_error$2,
    gantt_keep_work_tip: gantt_keep_work_tip$2,
    save_success: save_success$2,
    gantt_frame_load_fail: gantt_frame_load_fail$2,
    save_fail: save_fail$2,
    pk_network_exception: pk_network_exception$2,
    pk_saving: pk_saving$2,
    gantt_plugin_fail: gantt_plugin_fail$2,
    gantt_editing_tip: gantt_editing_tip$2,
    pk_discard: pk_discard$2,
    pk_zoom_in: pk_zoom_in$2,
    pk_zoom_out: pk_zoom_out$2,
    pk_use: pk_use$2,
    draft_edit_tip: draft_edit_tip$2,
    pk_load_fail: pk_load_fail$2,
    if_use_local_draft: if_use_local_draft$2,
    pk_this_time: pk_this_time$2,
    choose_time: choose_time$2,
    pk_hh_mm_ss: pk_hh_mm_ss$2,
    pk_y_d: pk_y_d$2,
    pk_y_d_ts: pk_y_d_ts$2,
    pk_text: pk_text$2,
    h1: h1$2,
    h2: h2$2,
    h3: h3$2,
    h4: h4$2,
    h5: h5$2,
    h6: h6$2,
    pk_catalog: pk_catalog$2,
    page_view_load_fail_click: page_view_load_fail_click$2,
    page_tree_no_sub_doc: page_tree_no_sub_doc$2,
    page_tree_no_perm: page_tree_no_perm$2,
    pk_load_fail_retry: pk_load_fail_retry$2,
    loading2: loading2$2,
    page_tree_deleted: page_tree_deleted$2,
    pk_pause: pk_pause$2,
    pk_mute: pk_mute$2,
    pk_untitled: pk_untitled$2,
    pk_play: pk_play$2,
    adjust_volume: adjust_volume$2,
    download_fail_retry: download_fail_retry$2,
    pk_download: pk_download$2,
    get_file_fail: get_file_fail$2,
    pk_network_fail: pk_network_fail$2,
    pk_upload_fail: pk_upload_fail$2,
    audio_not_support_tip: audio_not_support_tip$2,
    pk_volume: pk_volume$2,
    browser_not_support_tip: browser_not_support_tip$2,
    pk_zoom_in2: pk_zoom_in2$2,
    video_upload_tip: video_upload_tip$2,
    pk_video: pk_video$2,
    pk_zoom_out2: pk_zoom_out2$2,
    space_update_fail_tip: space_update_fail_tip$2,
    pk_recent_update: pk_recent_update$2,
    show_more: show_more$2,
    no_space_update: no_space_update$2,
    pk_restore: pk_restore$2
};

// This file was auto generated by resource-sync tools.
var resources = {
    "en": {
        parker: en_parker
    },
    "zh": {
        parker: zh_parker
    },
    "zh-HK": {
        parker: zhHK_parker
    }
};

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var I18nManager = /*#__PURE__*/ function() {
    function I18nManager() {
        _classCallCheck(this, I18nManager);
    }
    I18nManager.getInstance = function getInstance() {
        if (this.instance === null) {
            this.instance = createInstance();
            this.instance.init({
                // lng: 'zh',
                fallbackLng: "zh",
                ns: [
                    "parker"
                ],
                defaultNS: "parker",
                resources: resources,
                interpolation: {
                    escapeValue: false
                },
                react: {
                    useSuspense: false
                }
            });
            window.parkerI18nClient = this.instance;
        }
        return this.instance;
    };
    return I18nManager;
}();
I18nManager.instance = null;
var i18nClient = I18nManager.getInstance();

var LOCALES;
(function(LOCALES) {
    LOCALES["ZH"] = "zh";
    LOCALES["ZH_HK"] = "zh-HK";
    LOCALES["EN"] = "en";
})(LOCALES || (LOCALES = {}));

var isEn = function() {
    return i18nClient.getCurrentLocale() === LOCALES.EN;
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 向上寻找最近的display为block的DOM节点
 */ var findParentBlockNode = function(targetDOM) {
    var dom = targetDOM.parentNode;
    var flag = 0;
    // 防止查找节点层级过多
    while(flag < 40){
        if (!dom || dom.classList && dom.classList.contains("ProseMirror")) {
            return false;
        }
        if ([
            "block",
            "flex"
        ].includes(getComputedStyle(dom).display)) return dom;
        dom = dom.parentNode;
        flag++;
    }
    return null;
};
/**
 * 获取图片可设置的最大宽度
 */ function getMaxWidth(dom) {
    var blockNode = findParentBlockNode(dom);
    var defaultMaxWidth = 1920;
    if (!blockNode) {
        return defaultMaxWidth;
    }
    var parentTagName = blockNode.parentNode.tagName.toLowerCase();
    var maxWidth = blockNode.clientWidth - IMAGE_OFFSET;
    if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
        maxWidth = defaultMaxWidth;
    }
    return maxWidth;
}
var updateAttrs = function(data, pos) {
    return function(view) {
        var schema = view.state.schema;
        updateNodeAttrs({
            type: schema.nodes.image,
            data: data,
            pos: pos,
            view: view
        });
        return true;
    };
};
var getImageInfo = function() {
    var _ref = _asyncToGenerator(function(imgSrc) {
        return __generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    var img = new Image();
                    img.src = imgSrc;
                    img.onload = function() {
                        resolve({
                            width: img.width,
                            height: img.height
                        });
                    };
                    img.onerror = function() {
                        resolve(null);
                    };
                })
            ];
        });
    });
    return function getImageInfo(imgSrc) {
        return _ref.apply(this, arguments);
    };
}();
// 如果原图尺寸小于最小要求，进行调整
function adjustSize(data) {
    var width = data.width, height = data.height;
    if (width < MIN_IMG_SIZE && width <= height) {
        height = Math.ceil(20 * height / width);
        width = 20;
    } else if (height < MIN_IMG_SIZE && height <= width) {
        width = Math.ceil(20 * width / height);
        height = 20;
    }
    return _objectSpreadProps(_objectSpread$2({}, data), {
        width: width,
        height: height
    });
}
function formatImagData(data, view) {
    return _formatImagData.apply(this, arguments);
}
function _formatImagData() {
    _formatImagData = _asyncToGenerator(function(data, view) {
        var imgInfo, _tmp, editorDoc, _calculateSize, width, height;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = data.imgInfo;
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getImageInfo(data.src)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    imgInfo = _tmp;
                    if (!imgInfo) {
                        return [
                            2,
                            {}
                        ];
                    }
                    editorDoc = view.dom;
                    _calculateSize = calculateSize(imgInfo.width, imgInfo.height, editorDoc.getBoundingClientRect().width, data === null || data === void 0 ? void 0 : data.maxHeight), width = _calculateSize.width, height = _calculateSize.height;
                    data = adjustSize(_objectSpreadProps(_objectSpread$2({}, data.imgInfo, data), {
                        width: width,
                        height: height
                    }));
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _formatImagData.apply(this, arguments);
}
function createUploadMask(param) {
    var src = param.src, width = param.width;
    var widget = document.createElement("span");
    widget.setAttribute("class", "ct-image");
    widget.setAttribute("data-type", "ct-progress");
    var imgArea = src ? '<img src="'.concat(src, '" style="width: ').concat(width, 'px;" />') : '<div class="image-empty" />';
    var uploadErrorTip1 = i18nClient.t("image_upload_fail1", "抱歉，图片上传失败！");
    var uploadErrorTip2 = i18nClient.t("image_upload_fail2", "如果是从外部拖动、粘贴过来的图片，请下载原图并重新上传。");
    var uploadErrorTip3 = i18nClient.t("image_upload_fail3", "否则，请点击下方按钮进行重试。");
    var retry = i18nClient.t("pk_retry", "重试");
    var minWidth = isEn() ? "500px" : "400px";
    widget.innerHTML = "\n    ".concat(imgArea, '\n    <div class="ct-image-mask" style="min-width:').concat(minWidth, '">\n      <span class="ct-image-loading-icon"></span>\n      <span class="ct-image-progress-text">0%</span>\n      <span class="ct-image-reupload-container">\n        <span class="ct-image-reupload-text" style="top:10px;width:400px">').concat(uploadErrorTip1, '<br style="line-height:0">').concat(uploadErrorTip2, '<br style="line-height:0">').concat(uploadErrorTip3, '</span>\n        <button class="ct-image-reupload-btn">').concat(retry, "</button>\n      </span>\n    </div>\n  ");
    return widget;
}

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator$1 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * 参考自官网Demo：https://prosemirror.net/examples/upload/
 */ function findPlaceholder(view, id) {
    var decos = pluginKey.getState(view.state);
    var found = decos.find(null, null, function(spec) {
        return spec.id === id;
    });
    if (found.length) {
        return {
            pos: found[0].from,
            node: found[0].type.toDOM
        };
    }
    return null;
}
// 如果原图尺寸小于最小要求，进行调整
function adjustSize$1(data) {
    var width = data.width, height = data.height;
    if (width < MIN_IMG_SIZE && width <= height) {
        height = Math.ceil(20 * height / width);
        width = 20;
    } else if (height < MIN_IMG_SIZE && height <= width) {
        width = Math.ceil(20 * width / height);
        height = 20;
    }
    return _objectSpreadProps$1(_objectSpread$3({}, data), {
        width: width,
        height: height
    });
}
var onUpload = function(view, provider, pos) {
    // 使用 retry 标记是否为重传
    return function() {
        var _ref = _asyncToGenerator$1(function(file, retry) {
            var customUpload, blobUrl, imgData, _tmp, id, ret, attrs, _view_state, tr, schema, image, onProgress, data, _tmp1, placeholder, e, placeholder1, node, $btnUpload;
            return __generator$1(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customUpload = typeof file === "function" ? file : null;
                        blobUrl = customUpload ? "" : file.src || URL.createObjectURL(file);
                        if (!customUpload) return [
                            3,
                            1
                        ];
                        _tmp = null;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            formatImagData({
                                src: blobUrl
                            }, view)
                        ];
                    case 2:
                        _tmp = adjustSize$1.apply(void 0, [
                            _state.sent()
                        ]);
                        _state.label = 3;
                    case 3:
                        imgData = _tmp;
                        id = v4();
                        if (provider.beforeUpload) {
                            ret = provider.beforeUpload(file, id);
                            // 只有当校验函数显示返回 false 时才表示校验不通过
                            if (ret === false) {
                                view.focus();
                                return [
                                    2
                                ];
                            }
                        }
                        attrs = {
                            border: +sessionStorage.getItem(IMAGE_BORDER_KEY) === 1,
                            name: "image.jpeg",
                            src: blobUrl
                        };
                        _view_state = view.state, tr = _view_state.tr, schema = _view_state.schema;
                        image = schema.nodes.image;
                        // const isReUpload = !!pos;
                        if (typeof pos !== "number") pos = tr.selection.from;
                        if (!retry && !tr.selection.empty) {
                            tr.deleteSelection();
                        }
                        // 插入零宽度字符占位，并设置新选区，防止批量插入图片时位置错误
                        tr.setMeta(pluginKey, {
                            add: _objectSpreadProps$1(_objectSpread$3({
                                id: id,
                                pos: pos
                            }, imgData || {}), {
                                src: blobUrl
                            })
                        }).insertText(ZERO_WIDTH_SPACE, pos).setSelection(TextSelection.create(tr.doc, pos + 1));
                        view.dispatch(tr);
                        onProgress = function(param) {
                            var loaded = param.loaded, total = param.total;
                            var placeholder = findPlaceholder(view, id);
                            if (!placeholder) return;
                            var percent = Math.ceil(total ? loaded / total * 99 : 0);
                            placeholder.node.querySelector(".ct-image-progress-text").innerText = "".concat(percent, "%");
                        };
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            13,
                            ,
                            14
                        ]);
                        if (!customUpload) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            customUpload(onProgress)
                        ];
                    case 5:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 6:
                        return [
                            4,
                            provider.upload(file, onProgress)
                        ];
                    case 7:
                        _tmp1 = _state.sent();
                        _state.label = 8;
                    case 8:
                        data = _tmp1;
                        if (!!imgData) return [
                            3,
                            12
                        ];
                        if (!(customUpload && data.width !== 0)) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            formatImagData({
                                src: data.src,
                                imgInfo: data,
                                maxHeight: data.height
                            }, view)
                        ];
                    case 9:
                        // customUpload表示复制粘贴场景的图片上传，存在width属性说明非外部图片，为学城图片
                        imgData = adjustSize$1.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            12
                        ];
                    case 10:
                        return [
                            4,
                            formatImagData({
                                src: data.src
                            }, view)
                        ];
                    case 11:
                        imgData = adjustSize$1.apply(void 0, [
                            _state.sent()
                        ]);
                        _state.label = 12;
                    case 12:
                        placeholder = findPlaceholder(view, id);
                        // If the content around the placeholder has been deleted, drop
                        // the image
                        if (!placeholder) return [
                            2
                        ];
                        // Otherwise, insert it at the placeholder's position, and remove
                        // the placeholder
                        view.dispatch(view.state.tr.replaceWith(placeholder.pos, placeholder.pos + 1, image.create(_objectSpreadProps$1(_objectSpread$3({}, attrs, imgData || {}), {
                            src: data.src
                        }))).setMeta(pluginKey, {
                            remove: {
                                id: id
                            }
                        }));
                        view.focus();
                        return [
                            3,
                            14
                        ];
                    case 13:
                        e = _state.sent();
                        console.error(e);
                        placeholder1 = findPlaceholder(view, id);
                        if (!placeholder1) return [
                            2
                        ];
                        node = placeholder1.node;
                        node.querySelector(".ct-image-mask").classList.add("upload-failed");
                        $btnUpload = node.querySelector(".ct-image-reupload-container");
                        // 上面组件的 class 变化会导致 pm 重新计算选区，计算的位置不对，需要重新设置
                        setTimeout(function() {
                            view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, placeholder1.pos + 1)));
                        }, 0);
                        $btnUpload.addEventListener("click", function() {
                            var curPlaceholder = findPlaceholder(view, id);
                            if (!curPlaceholder) return;
                            view.dispatch(view.state.tr.setMeta(pluginKey, {
                                remove: {
                                    id: id
                                }
                            }));
                            // 删除之前清理多余的零宽度字符，这样不用区分是重传还是第一次上传
                            var delPos = placeholder1.pos;
                            view.dispatch(view.state.tr.delete(delPos, delPos + 1));
                            onUpload(view, provider, curPlaceholder.pos)(file, true);
                        });
                        return [
                            3,
                            14
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file, retry) {
            return _ref.apply(this, arguments);
        };
    }();
};
var selectFile = function(param) {
    var accept = param.accept, _param_multiple = param.multiple, multiple = _param_multiple === void 0 ? true : _param_multiple;
    return new Promise(function(resolve) {
        var input = document.createElement("input");
        input.setAttribute("type", "file");
        if (multiple) {
            input.setAttribute("multiple", "multiple");
        }
        input.setAttribute("accept", accept);
        input.onchange = function(e) {
            var files = e.target.files;
            input.remove();
            resolve(files);
        };
        input.click();
    });
};

var img = "data:image/svg+xml,%3csvg width='256' height='256' xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3cstyle/%3e%3c/defs%3e%3cpath d='M37.333 160L96 101.333 154.667 160l32-32 32 32V58.667H37.333V160zM234.667 48v160a5.333 5.333 0 0 1-5.334 5.333H26.667A5.333 5.333 0 0 1 21.333 208V48a5.333 5.333 0 0 1 5.334-5.333h202.666A5.333 5.333 0 0 1 234.667 48zm-80 64a16 16 0 1 1 0-32 16 16 0 0 1 0 32z'/%3e%3c/svg%3e";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function useForceUpdate() {
    var _useState = _slicedToArray(useState(0), 2), setTick = _useState[1];
    var update = useCallback(function() {
        setTick(function(tick) {
            return tick + 1;
        });
    }, []);
    return update;
}

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
styleInject(css_248z);

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var Resizer = function(param) {
    var $container = param.$container, view = param.view, getPos = param.getPos, initialWidth = param.initialWidth, initialHeight = param.initialHeight, _param_fixedRatio = param.fixedRatio, fixedRatio = _param_fixedRatio === void 0 ? true : _param_fixedRatio, _param_autoHeight = param.autoHeight, autoHeight = _param_autoHeight === void 0 ? false : _param_autoHeight, _param_hideInfo = param.hideInfo, hideInfo = _param_hideInfo === void 0 ? false : _param_hideInfo, _param_limit = param.limit, limit = _param_limit === void 0 ? {} : _param_limit, onResizeStart = param.onResizeStart, onResizeEnd = param.onResizeEnd;
    if (!$container || !getPos()) return null;
    var limitRef = useRef({});
    limitRef.current.minWidth = limit.minWidth || 20;
    limitRef.current.minHeight = limit.minHeight || 20;
    limitRef.current.maxHeight = limit.maxHeight || Infinity;
    var _useState = _slicedToArray$1(useState("rb"), 2), infoPosition = _useState[0], setInfoPosition = _useState[1];
    var wrapperRef = useRef();
    // 获取最大宽度
    var pos = getPos();
    var doc = view.state.doc;
    // 获取父级block节点
    var blockNode = findParentNodeClosestToPos(doc.resolve(pos), function(n) {
        return n.isBlock;
    });
    var $blockNode = view.nodeDOM((blockNode === null || blockNode === void 0 ? void 0 : blockNode.pos) || 0);
    if (!$blockNode) {
        return null;
    }
    limitRef.current.maxWidth = limit.maxWidth || $blockNode.clientWidth;
    var ratio = initialHeight / initialWidth;
    if (fixedRatio) {
        limitRef.current.minHeight = Math.max(limitRef.current.minHeight, limitRef.current.minWidth * ratio);
        limitRef.current.minWidth = Math.max(limitRef.current.minWidth, limitRef.current.minHeight / ratio);
        limitRef.current.maxHeight = limitRef.current.maxWidth * ratio;
    }
    limitRef.current.minWidth = Math.min(limitRef.current.minWidth, limitRef.current.maxWidth);
    limitRef.current.minHeight = Math.min(limitRef.current.minHeight, limitRef.current.maxHeight);
    var startX = useRef(0);
    var startY = useRef(0);
    var isReverseX = useRef(false);
    var isReverseY = useRef(false);
    var initialWidthRef = useRef(0);
    var initialHeightRef = useRef(0);
    initialWidthRef.current = initialWidth;
    initialHeightRef.current = initialHeight;
    var currentSize = useRef({
        width: initialWidth,
        height: initialHeight
    });
    var update = useForceUpdate();
    var limitSize = function() {
        var _currentSize_current = currentSize.current, width = _currentSize_current.width, height = _currentSize_current.height;
        if (width >= limitRef.current.maxWidth) {
            currentSize.current.width = limitRef.current.maxWidth;
        } else if (width <= limitRef.current.minWidth) {
            currentSize.current.width = limitRef.current.minWidth;
        }
        if (height >= limitRef.current.maxHeight) {
            currentSize.current.height = limitRef.current.maxHeight;
        } else if (height <= limitRef.current.minHeight) {
            currentSize.current.height = limitRef.current.minHeight;
        }
    };
    useEffect(function() {
        var onMouseDown = function(e) {
            var classList = e.target && e.target.classList;
            if (!classList) {
                return;
            }
            var posList = [
                "lt",
                "rt",
                "lb",
                "rb"
            ];
            var posName = posList.find(function(item) {
                return classList.contains(item);
            });
            if (posName) {
                e.stopPropagation();
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                handleMouseDown(e, posName);
            }
        };
        var wrapper = wrapperRef.current;
        wrapper.addEventListener("mousedown", onMouseDown, false);
        return function() {
            wrapper.removeEventListener("mousedown", onMouseDown, false);
        };
    });
    useEffect(function() {
        currentSize.current.width = initialWidth;
        currentSize.current.height = initialHeight;
        if (!autoHeight) {
            // 防止容器节点大小没有同步更新
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        update();
    }, [
        initialWidth
    ]);
    var handleMouseMove = useCallback(function(e) {
        e.preventDefault();
        e.stopPropagation();
        var diffX = isReverseX.current ? startX.current - e.clientX : e.clientX - startX.current;
        var diffY = isReverseY.current ? startY.current - e.clientY : e.clientY - startY.current;
        currentSize.current.width = initialWidthRef.current + diffX;
        currentSize.current.height = initialHeightRef.current + diffY;
        if (fixedRatio) {
            currentSize.current.height = currentSize.current.width * ratio;
        }
        limitSize();
        currentSize.current.width = Math.round(currentSize.current.width);
        currentSize.current.height = Math.round(currentSize.current.height);
        $container.style.width = "".concat(currentSize.current.width, "px");
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        // 更新尺寸大小的显示
        update();
    }, []);
    var handleMouseUp = useCallback(function() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        onResizeEnd({
            width: currentSize.current.width,
            height: currentSize.current.height
        });
        if (!autoHeight) {
            $container.style.height = "".concat(currentSize.current.height, "px");
        }
        $container.style.width = "".concat(currentSize.current.width, "px");
    }, []);
    var handleMouseDown = function(e, position) {
        isReverseX.current = position === "lt" || position === "lb";
        isReverseY.current = position === "lt" || position === "lr";
        startX.current = e.clientX;
        startY.current = e.clientY;
        setInfoPosition(position);
        if (onResizeStart) {
            onResizeStart();
        }
        document.addEventListener("mousemove", handleMouseMove, {
            passive: false
        });
        document.addEventListener("mouseup", handleMouseUp);
    };
    // 当图片尺寸较大时，扩大热区
    var largeHotArea = useMemo(function() {
        return currentSize.current.height >= 30 && currentSize.current.width >= 30;
    }, [
        currentSize.current.height,
        currentSize.current.width
    ]);
    var resizerPrefix = classNamePrefix("pc-resizer");
    var pointerCls = "".concat(resizerPrefix, "-point");
    return /*#__PURE__*/ React.createElement("div", {
        className: resizerPrefix,
        ref: wrapperRef
    }, /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " lt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " rt ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " lb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(pointerCls, " rb ").concat(largeHotArea && "large-hot-area")
    }), /*#__PURE__*/ React.createElement("span", {
        className: "".concat(resizerPrefix, "-info ").concat(infoPosition, " ").concat((currentSize.current.width < 65 || currentSize.current.height < 30) && "out", " ").concat(hideInfo ? "auto-hide" : "")
    }, "".concat(currentSize.current.width, " x ").concat(currentSize.current.height)));
};

var css_248z$1 = ".ct-node-view-dom .ct-image{margin:0}.ct-node-view-dom .ct-image img{max-width:100%;width:100%}.ct-node-view-dom.ProseMirror-selectednode .ct-image-toobar-wrapper{display:flex}";
styleInject(css_248z$1);

function _arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray$2(arr, i) {
    return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}
function _unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
var ImageNodeView = function(param) {
    var store = param.store;
    return function(props) {
        var wrapperRef = useRef(null);
        var imageRef = useRef();
        var _props_attrs = props.attrs, name = _props_attrs.name, border = _props_attrs.border, link = _props_attrs.link, width = _props_attrs.width, small = _props_attrs.small, origin = _props_attrs.origin, height = _props_attrs.height, src = _props_attrs.src, view = props.view, getPos = props.getPos, provider = props.provider, editorEventEmitter = props.editorEventEmitter;
        var _useState = _slicedToArray$2(useState(false), 2), loadError = _useState[0], setLoadError = _useState[1];
        var _useState1 = _slicedToArray$2(useState(false), 2), loadSuccess = _useState1[0], setLoadSuccess = _useState1[1];
        var _useState2 = _slicedToArray$2(useState(false), 2), imageShow = _useState2[0], setImageShow = _useState2[1];
        // const [wrapperHeight, setWrapperHeight] = useState(height);
        var wrapperHeight = useRef(height);
        var _useState3 = _slicedToArray$2(useState(0), 2), maxWidth = _useState3[0], setMaxWidth = _useState3[1];
        var _useState4 = _slicedToArray$2(useState(0), 2), naturalWidth = _useState4[0], setNaturalWidth = _useState4[1];
        var radio = useRef(1); // 记录图片长宽比
        var imgPrefix = classNamePrefix("image");
        var domAttrs = useMemo(function() {
            return {
                className: "".concat(imgPrefix).concat(border ? " ".concat(imgPrefix, "-border") : ""),
                "data-link": link
            };
        }, [
            border,
            link
        ]);
        useEffect(function() {
            var io = null;
            try {
                io = new IntersectionObserver(function(entries) {
                    if (entries[entries.length - 1].isIntersecting) {
                        setImageShow(true);
                        io.disconnect();
                    }
                });
                io.observe(wrapperRef.current);
            } catch (error) {
                setImageShow(true);
            }
            return function() {
                io && io.disconnect();
            };
        }, []);
        var _useState5 = _slicedToArray$2(useState({
            "data-small": small,
            "data-origin": origin,
            src: "",
            alt: name.length > 100 ? "".concat(name.substr(0, 100), "...") : name,
            width: "".concat(width || IMAGE_DEFAULT_WIDTH)
        }), 2), imageAttrs = _useState5[0], setImageAttrs = _useState5[1];
        useEffect(function() {
            var realSrc = src;
            if (!realSrc) {
                realSrc = "";
            }
            if (provider.formatUrl) {
                realSrc = provider.formatUrl(realSrc);
            }
            setImageAttrs(function(_) {
                return _objectSpreadProps$2(_objectSpread$4({}, _), {
                    src: realSrc
                });
            });
        }, [
            src
        ]);
        var onImageError = function(e) {
            setLoadError(true);
            emitTableHeightChange(wrapperRef.current, editorEventEmitter);
        };
        var onImageLoad = function() {
            if (provider.onImageLoad) {
                provider.onImageLoad(imageAttrs.src);
            }
            setLoadSuccess(true);
            var current = imageRef.current;
            if (current) {
                setMaxWidth(getMaxWidth(imageRef.current));
                setNaturalWidth(current.naturalWidth);
                radio.current = current.naturalHeight / current.naturalWidth;
            }
            emitTableHeightChange(wrapperRef.current, editorEventEmitter);
        };
        var handleResizeStart = function() {
            if (store && store.popContainer) {
                store.popContainer.classList.add("resizing");
            }
        };
        var handleResizeEnd = function(size) {
            var state = view.state, dispatch = view.dispatch;
            var tr = state.tr, doc = state.doc;
            var pos = getPos();
            var node = doc.nodeAt(pos);
            dispatch(tr.setNodeMarkup(pos, null, _objectSpreadProps$2(_objectSpread$4({}, node.attrs), {
                width: size.width,
                height: size.height
            })).setSelection(NodeSelection.create(tr.doc, pos)) // 重新设置选区
            );
            setImageAttrs(function(_) {
                return _objectSpreadProps$2(_objectSpread$4({}, _), {
                    width: size.width
                });
            });
            if (store && store.popContainer) {
                store.popContainer.classList.remove("resizing");
            }
        };
        useEffect(function() {
            if (loadError) {
                setImageAttrs(function(_) {
                    return _objectSpreadProps$2(_objectSpread$4({}, _), {
                        src: img
                    });
                });
            }
        }, [
            loadError
        ]);
        useEffect(function() {
            // 在没有懒加载之前需要有 height 保证占位
            if (wrapperRef.current) {
                var _wrapperRef_current_getBoundingClientRect = wrapperRef.current.getBoundingClientRect(), realWidth = _wrapperRef_current_getBoundingClientRect.width;
                if (width > realWidth) {
                    // setWrapperHeight(Math.ceil((realWidth * height) / width));
                    wrapperHeight.current = Math.ceil(realWidth * height / width);
                    return;
                }
            }
            // setWrapperHeight(height);
            wrapperHeight.current = height;
        }, [
            height,
            width,
            loadSuccess
        ]);
        useEffect(function() {
            if (width !== +imageAttrs.width) {
                setImageAttrs(function(_) {
                    return _objectSpreadProps$2(_objectSpread$4({}, _), {
                        width: width
                    });
                });
            }
        }, [
            width,
            height,
            loadSuccess
        ]);
        // 因为容器 span 有 max-width: 100% 所以要考虑超出容器宽度时显示的其实为容器宽度
        var initialWidth = Math.min(+width || IMAGE_DEFAULT_WIDTH, maxWidth);
        return /*#__PURE__*/ React.createElement("span", _extends({
            style: {
                width: "".concat(width || IMAGE_DEFAULT_WIDTH, "px"),
                height: loadSuccess ? "auto" : "".concat(wrapperHeight.current || IMAGE_DEFAULT_HEIGHT, "px")
            }
        }, domAttrs, {
            ref: wrapperRef
        }), imageShow && /*#__PURE__*/ React.createElement("img", _extends({}, imageAttrs, {
            alt: imageAttrs.alt,
            ref: imageRef,
            width: imageAttrs.width || IMAGE_DEFAULT_WIDTH,
            "data-maxwidth": maxWidth,
            "data-naturalwidth": naturalWidth,
            onLoad: onImageLoad,
            onError: onImageError
        })), loadSuccess && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Resizer, {
            $container: wrapperRef.current,
            view: view,
            getPos: getPos,
            autoHeight: true,
            initialWidth: initialWidth,
            initialHeight: width ? Math.round(width * radio.current) : IMAGE_DEFAULT_HEIGHT,
            onResizeStart: handleResizeStart,
            onResizeEnd: handleResizeEnd,
            limit: {
                minWidth: MIN_IMG_SIZE,
                minHeight: 1
            }
        })));
    };
};

function _arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$3(arr, i) {
    return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3();
}
function _unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}
var getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = _slicedToArray$3(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        render(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = ReactDOM.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

var css_248z$2 = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
styleInject(css_248z$2);

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var SHOW = "show";
var HIDE = "hide";
var Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        _classCallCheck$1(this, Popover);
        this.popoverState = HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === SHOW && !forceUpdate) {
            return;
        }
        if (!target || !_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        render(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(HIDE);
    };
    _proto.destroy = function destroy() {
        emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
var DEFAULT_HEIGHT = 34;
var DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        _classCallCheck$2(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = _objectSpread$5({}, DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new Popover(_objectSpread$5({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var css_248z$3 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
styleInject(css_248z$3);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Button = /*#__PURE__*/ function(Component) {
    _inherits(Button, Component);
    var _super = _createSuper(Button);
    function Button() {
        _classCallCheck$3(this, Button);
        return _super.apply(this, arguments);
    }
    var _proto = Button.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, type = _this_props.type, _this_props_prefix = _this_props.prefix, prefix = _this_props_prefix === void 0 ? "button" : _this_props_prefix, disabled = _this_props.disabled, onClick = _this_props.onClick;
        var customPrefix = classNamePrefix(prefix);
        var classes = _defineProperty$6({}, "".concat(customPrefix, "-disabled"), disabled);
        if (type) {
            classes["".concat(customPrefix, "-").concat(type)] = true;
        }
        return /*#__PURE__*/ React.createElement("button", {
            disabled: disabled,
            className: classNames(customPrefix, classes),
            onClick: onClick
        }, children);
    };
    return Button;
}(Component);

var css_248z$4 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
styleInject(css_248z$4);

/* eslint-disable jsx-a11y/control-has-associated-label */ function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var defaultModalWidth = {
    small: 400,
    middle: 600,
    large: 800,
    super: 960
};
var Modal = /*#__PURE__*/ function(Component) {
    _inherits$1(Modal, Component);
    var _super = _createSuper$1(Modal);
    function Modal() {
        _classCallCheck$4(this, Modal);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onKeyDown = function(e) {
            var _this_props = _this.props, onOk = _this_props.onOk, canEnter = _this_props.canEnter;
            if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
                onOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.render = function render() {
        var _this_props = this.props, children = _this_props.children, className = _this_props.className, title = _this_props.title, contentClassName = _this_props.contentClassName, _this_props_okText = _this_props.okText, okText = _this_props_okText === void 0 ? i18nClient.t("pk_confirm", "确定") : _this_props_okText, _this_props_cancelText = _this_props.cancelText, cancelText = _this_props_cancelText === void 0 ? i18nClient.t("pk_cancel", "取消") : _this_props_cancelText, onOk = _this_props.onOk, disabled = _this_props.disabled, onCancel = _this_props.onCancel, _this_props_showFooter = _this_props.showFooter, showFooter = _this_props_showFooter === void 0 ? true : _this_props_showFooter, wrapper = _this_props.wrapper, userPrefix = _this_props.prefix, size = _this_props.size;
        var prefix = classNamePrefix(userPrefix);
        return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mask"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-content ").concat(contentClassName || ""),
            style: {
                width: defaultModalWidth[size]
            },
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-header")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-header-title")
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-header-close"),
            onClick: onCancel
        }, /*#__PURE__*/ React.createElement("button", {
            className: "".concat(prefix, "-header-close-icon")
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-body")
        }, children), showFooter && /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, "-footer")
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: onCancel
        }, cancelText), /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            className: "ok",
            onClick: onOk,
            disabled: disabled
        }, okText)))), wrapper || document.body);
    };
    return Modal;
}(Component);
Modal.defaultProps = {
    prefix: "base-modal",
    size: "middle",
    canEnter: false
};

var css_248z$5 = '.ct-checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-checkbox input{display:none}.ct-checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-checkbox input:checked+.checkbox-bg:after{content:" ";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
styleInject(css_248z$5);

function _assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$2(self);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$2(this, result);
    };
}
var noop = function() {};
var CheckBox = /*#__PURE__*/ function(Component) {
    _inherits$2(CheckBox, Component);
    var _super = _createSuper$2(CheckBox);
    function CheckBox() {
        _classCallCheck$5(this, CheckBox);
        return _super.apply(this, arguments);
    }
    var _proto = CheckBox.prototype;
    _proto.render = function render() {
        // 设置 onChange 的默认值，防止出现警告
        var _this_props = this.props, checked = _this_props.checked, onClick = _this_props.onClick, _this_props_onChange = _this_props.onChange, onChange = _this_props_onChange === void 0 ? noop : _this_props_onChange, children = _this_props.children;
        return /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("checkbox"),
            onClick: onClick
        }, /*#__PURE__*/ React.createElement("input", {
            type: "checkbox",
            checked: checked,
            onChange: onChange
        }), /*#__PURE__*/ React.createElement("span", {
            className: "checkbox-bg"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "checkbox-label"
        }, children));
    };
    return CheckBox;
}(Component);

var css_248z$6 = '.ct-icon-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-icon-item svg{margin:4px 0 0 4px}.ct-icon-item.close{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-icon-item.error{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E9%94%99%E8%AF%AF%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-296.000000%2C -544.000000)%22 fill%3D%22%23F05E50%22%3E            %3Cpath fill%3D%22%23F05E50%22 d%3D%22M304%2C544 C308.41824%2C544 312%2C547.58176 312%2C552 C312%2C556.41824 308.41824%2C560 304%2C560 C299.58176%2C560 296%2C556.41824 296%2C552 C296%2C547.58176 299.58176%2C544 304%2C544 Z M299.2%2C552 C299.2%2C552.667362 299.735663%2C553.2 300.396436%2C553.2 L307.603564%2C553.2 C308.256356%2C553.2 308.8%2C552.662742 308.8%2C552 C308.8%2C551.332638 308.264337%2C550.8 307.603564%2C550.8 L300.396436%2C550.8 C299.743644%2C550.8 299.2%2C551.337258 299.2%2C552 Z%22 id%3D%22tost-%E9%94%99%E8%AF%AF%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.success{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E6%88%90%E5%8A%9F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-222.000000%2C -544.000000)%22 fill%3D%22%2370B123%22%3E            %3Cpath fill%3D%22%2370B123%22 d%3D%22M228.93934%2C552.865274 L226.802094%2C550.728029 C226.3405%2C550.266435 225.576187%2C550.26192 225.107558%2C550.730549 C224.635662%2C551.202445 224.637801%2C551.957848 225.105038%2C552.425085 L228.079926%2C555.399974 C228.314894%2C555.634941 228.628301%2C555.751472 228.941218%2C555.747447 C229.252578%2C555.751485 229.564571%2C555.634156 229.802094%2C555.396633 L234.898303%2C550.300424 C235.359897%2C549.83883 235.364412%2C549.074517 234.895783%2C548.605887 C234.423887%2C548.133991 233.668484%2C548.13613 233.201247%2C548.603367 L228.93934%2C552.865274 Z M238%2C552 C238%2C553.451396 237.642365%2C554.789924 236.927083%2C556.015625 C236.211802%2C557.241326 235.241326%2C558.211802 234.015625%2C558.927083 C232.789924%2C559.642365 231.451396%2C560 230%2C560 C228.548604%2C560 227.210076%2C559.642365 225.984375%2C558.927083 C224.758674%2C558.211802 223.788198%2C557.241326 223.072917%2C556.015625 C222.357635%2C554.789924 222%2C553.451396 222%2C552 C222%2C550.548604 222.357635%2C549.210076 223.072917%2C547.984375 C223.788198%2C546.758674 224.758674%2C545.788198 225.984375%2C545.072917 C227.210076%2C544.357635 228.548604%2C544 230%2C544 C231.451396%2C544 232.789924%2C544.357635 234.015625%2C545.072917 C235.241326%2C545.788198 236.211802%2C546.758674 236.927083%2C547.984375 C237.642365%2C549.210076 238%2C550.548604 238%2C552 Z%22 id%3D%22tost-%E6%88%90%E5%8A%9F%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.edit{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E7%BC%96%E8%BE%91%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-164.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E7%BC%96%E8%BE%91%22 transform%3D%22translate(164.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M13%2C7 C13.2761424%2C7 13.5%2C7.22385763 13.5%2C7.5 C13.5%2C7.77614237 13.2761424%2C8 13%2C8 L8%2C8 L8%2C8 C7.44771525%2C8 7%2C8.44771525 7%2C9 L7%2C9 L7%2C18 C7%2C18.5522847 7.44771525%2C19 8%2C19 L17%2C19 C17.5522847%2C19 18%2C18.5522847 18%2C18 L18%2C18 L18%2C13 C18%2C12.7238576 18.2238576%2C12.5 18.5%2C12.5 C18.7761424%2C12.5 19%2C12.7238576 19%2C13 L19%2C11 L19%2C18 L19%2C18 C19%2C19.1045695 18.1045695%2C20 17%2C20 L8%2C20 L8%2C20 C6.8954305%2C20 6%2C19.1045695 6%2C18 L6%2C9 L6%2C9 C6%2C7.8954305 6.8954305%2C7 8%2C7 L8%2C7 L15%2C7 L13%2C7 Z M19.8535534%2C6.14644661 C20.0488155%2C6.34170876 20.0488155%2C6.65829124 19.8535534%2C6.85355339 L13.4895924%2C13.2175144 C13.2943302%2C13.4127766 12.9777477%2C13.4127766 12.7824856%2C13.2175144 C12.5872234%2C13.0222523 12.5872234%2C12.7056698 12.7824856%2C12.5104076 L19.1464466%2C6.14644661 C19.3417088%2C5.95118446 19.6582912%2C5.95118446 19.8535534%2C6.14644661 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.link{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(-908.000000%2C -565.000000)%22%3E      %3Cg transform%3D%22translate(8.500000%2C 565.000000)%22%3E        %3Cg transform%3D%22translate(0.500000%2C 0.000000)%22 fill%3D%22%23666666%22%3E          %3Cg transform%3D%22translate(899.000000%2C 0.000000)%22%3E            %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L13.4302151%2C11.1475865 L12.7191158%2C11.8586857 L13.4302151%2C12.5697849 C14.2156736%2C13.3552435 14.2156736%2C14.6287234 13.4302151%2C15.4141819 L13.2808842%2C15.5635128 L12.9253346%2C15.2079632 L13.9919834%2C16.274612 L16.1252811%2C14.1413143 L15.4141819%2C13.4302151 L17.4052599%2C11.439137 C18.1907184%2C10.6536785 18.1907184%2C9.38019862 17.4052599%2C8.59474009 C16.6198014%2C7.80928156 15.3463215%2C7.80928156 14.560863%2C8.59474009 L12.7191158%2C10.4364872 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.visitLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8E%BB%E6%9F%A5%E7%9C%8B%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-587.000000%2C -162.000000)%22%3E            %3Cg id%3D%22Group-8%22 transform%3D%22translate(62.000000%2C 128.000000)%22%3E                %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 34.000000)%22%3E%3C%2Fg%3E                %3Cg id%3D%22Group-2%22 transform%3D%22translate(0.000000%2C 34.000000)%22 fill%3D%22%23666666%22%3E                    %3Cg id%3D%22%E5%8E%BB%E6%9F%A5%E7%9C%8B%22 transform%3D%22translate(525.000000%2C 0.000000)%22%3E                        %3Cpath d%3D%22M6.67363116%2C16 L7.80156483%2C16 C8.83909243%2C17.7939653 10.7785899%2C19.0009766 13%2C19.0009766 C16.3142478%2C19.0009766 19.0009766%2C16.3142478 19.0009766%2C13 C19.0009766%2C9.68575216 16.3142478%2C6.99902344 13%2C6.99902344 C10.7785899%2C6.99902344 8.83909243%2C8.20603473 7.80156483%2C10 L6.67363116%2C10 C7.7970951%2C7.63505267 10.207604%2C6 13%2C6 C16.8659932%2C6 20%2C9.13400675 20%2C13 C20%2C16.8659932 16.8659932%2C20 13%2C20 C10.207604%2C20 7.7970951%2C18.3649473 6.67363116%2C16 Z M14.1464466%2C14.767767 L15.4142136%2C13.5 L6.62132034%2C13.5 C6.34517797%2C13.5 6.12132034%2C13.2761424 6.12132034%2C13 C6.12132034%2C12.7238576 6.34517797%2C12.5 6.62132034%2C12.5 L15.4142136%2C12.5 L14.1464466%2C11.232233 C13.9511845%2C11.0369709 13.9511845%2C10.7203884 14.1464466%2C10.5251263 C14.3417088%2C10.3298641 14.6582912%2C10.3298641 14.8535534%2C10.5251263 L16.9535151%2C12.6262866 C16.9607818%2C12.6327579 16.967905%2C12.6394779 16.9748737%2C12.6464466 C17.1701359%2C12.8417088 17.1701359%2C13.1582912 16.9748737%2C13.3535534 L14.8535534%2C15.4748737 C14.6582912%2C15.6701359 14.3417088%2C15.6701359 14.1464466%2C15.4748737 C13.9511845%2C15.2796116 13.9511845%2C14.9630291 14.1464466%2C14.767767 Z%22%3E%3C%2Fpath%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.cancelLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8F%96%E6%B6%88%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-96.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E6%8F%92%E5%85%A5%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(96.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L14.560863%2C8.59474009 C15.3463215%2C7.80928156 16.6198014%2C7.80928156 17.4052599%2C8.59474009 C18.1907184%2C9.38019862 18.1907184%2C10.6536785 17.4052599%2C11.439137 L15.4141819%2C13.4302151 L16.1252811%2C14.1413143 L13.9919834%2C16.274612 L12.9253346%2C15.2079632 L13.2808842%2C15.5635128 L13.4302151%2C15.4141819 C14.2156736%2C14.6287234 14.2156736%2C13.3552435 13.4302151%2C12.5697849 L12.7191158%2C11.8586857 L13.4302151%2C11.1475865 L12.7191158%2C10.4364872 Z M7.35355339%2C7.35355339 C7.54881554%2C7.15829124 7.86539803%2C7.15829124 8.06066017%2C7.35355339 L9.47487373%2C8.76776695 C9.67013588%2C8.9630291 9.67013588%2C9.27961159 9.47487373%2C9.47487373 C9.27961159%2C9.67013588 8.9630291%2C9.67013588 8.76776695%2C9.47487373 L7.35355339%2C8.06066017 C7.15829124%2C7.86539803 7.15829124%2C7.54881554 7.35355339%2C7.35355339 Z M16.3535534%2C16.3535534 C16.5488155%2C16.1582912 16.865398%2C16.1582912 17.0606602%2C16.3535534 L18.4748737%2C17.767767 C18.6701359%2C17.9630291 18.6701359%2C18.2796116 18.4748737%2C18.4748737 C18.2796116%2C18.6701359 17.9630291%2C18.6701359 17.767767%2C18.4748737 L16.3535534%2C17.0606602 C16.1582912%2C16.865398 16.1582912%2C16.5488155 16.3535534%2C16.3535534 Z M17%2C14.5 C17%2C14.2238576 17.2238576%2C14 17.5%2C14 L19.5%2C14 C19.7761424%2C14 20%2C14.2238576 20%2C14.5 C20%2C14.7761424 19.7761424%2C15 19.5%2C15 L17.5%2C15 C17.2238576%2C15 17%2C14.7761424 17%2C14.5 Z M6%2C11.5 L6%2C11.5 C6%2C11.2238576 6.22385763%2C11 6.5%2C11 L8.5%2C11 C8.77614237%2C11 9%2C11.2238576 9%2C11.5 C9%2C11.7761424 8.77614237%2C12 8.5%2C12 L6.5%2C12 L6.5%2C12 C6.22385763%2C12 6%2C11.7761424 6%2C11.5 L6%2C11.5 Z M11.5%2C6 L11.5%2C6 C11.7761424%2C6 12%2C6.22385763 12%2C6.5 L12%2C8.5 C12%2C8.77614237 11.7761424%2C9 11.5%2C9 C11.2238576%2C9 11%2C8.77614237 11%2C8.5 L11%2C6.5 L11%2C6.5 C11%2C6.22385763 11.2238576%2C6 11.5%2C6 L11.5%2C6 Z M14.5%2C17 C14.7761424%2C17 15%2C17.2238576 15%2C17.5 L15%2C19.5 C15%2C19.7761424 14.7761424%2C20 14.5%2C20 C14.2238576%2C20 14%2C19.7761424 14%2C19.5 L14%2C17.5 C14%2C17.2238576 14.2238576%2C17 14.5%2C17 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomin{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25%22 fill%3D%22%23666%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomout{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4-Copy%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}';
styleInject(css_248z$6);

function _assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$3(self);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
var _typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$3(this, result);
    };
}
var IconItem = /*#__PURE__*/ function(Component) {
    _inherits$3(IconItem, Component);
    var _super = _createSuper$3(IconItem);
    function IconItem() {
        _classCallCheck$6(this, IconItem);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasTooltip: false
        };
        return _this;
    }
    var _proto = IconItem.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, tip = _this_props.tip, onClick = _this_props.onClick, _this_props_type = _this_props.type, type = _this_props_type === void 0 ? "" : _this_props_type, icon = _this_props.icon;
        var hasTooltip = this.state.hasTooltip;
        var bgStyle = null;
        if (icon) {
            var backgroundImage = icon;
            if (typeof backgroundImage === "string" && !backgroundImage.startsWith("url(")) {
                // 如果只提供了图片地址，拼出合法的 css 图片链接字符串
                backgroundImage = "url(".concat(backgroundImage, ")");
            }
            bgStyle = {
                backgroundImage: backgroundImage
            };
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: "".concat(classNamePrefix("icon-item"), " ").concat(type || ""),
            style: bgStyle,
            onMouseEnter: function() {
                return _this.setState({
                    hasTooltip: true
                });
            },
            onMouseLeave: function() {
                return _this.setState({
                    hasTooltip: false
                });
            },
            onClick: onClick
        }, hasTooltip && /*#__PURE__*/ React.createElement("span", {
            className: classNamePrefix("base-toolbar-tooltip")
        }, tip));
    };
    return IconItem;
}(Component);

var css_248z$7 = '.ct-base-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-base-toolbar .split{width:1px;height:14px;margin-top:0;background:#d9d9d9}.ct-base-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-base-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}';
styleInject(css_248z$7);

/**
 * 工具条组件
 */ function _assertThisInitialized$4(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$7(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$4(o) {
    _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$4(o);
}
function _inherits$4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$4(subClass, superClass);
}
function _possibleConstructorReturn$4(self, call) {
    if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$4(self);
}
function _setPrototypeOf$4(o, p) {
    _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$4(o, p);
}
var _typeof$4 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$4(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$4(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$4(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$4(this, result);
    };
}
var Toolbar = /*#__PURE__*/ function(Component) {
    _inherits$4(Toolbar, Component);
    var _super = _createSuper$4(Toolbar);
    function Toolbar() {
        _classCallCheck$7(this, Toolbar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderItem = function(tool) {
            var custom = tool.custom, title = tool.title, icon = tool.icon, callback = tool.callback;
            return custom || /*#__PURE__*/ React.createElement(IconItem, {
                key: title,
                type: icon,
                onClick: callback,
                tip: title
            });
        };
        _this.renderToolGroup = function(group, index, split) {
            return /*#__PURE__*/ React.createElement(Fragment, {
                key: index
            }, group.map(function(tool) {
                return _this.renderItem(tool);
            }), split && /*#__PURE__*/ React.createElement("div", {
                className: "split"
            }));
        };
        return _this;
    }
    var _proto = Toolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, _this_props_tools = _this_props.tools, tools = _this_props_tools === void 0 ? [] : _this_props_tools, className = _this_props.className;
        var prefix = classNamePrefix("toolbox");
        var lastIndex = tools.length - 1;
        return /*#__PURE__*/ React.createElement("div", {
            className: "".concat(prefix, " ").concat(className || "")
        }, tools.map(function(group, index) {
            return _this.renderToolGroup(group, index, index !== lastIndex);
        }));
    };
    return Toolbar;
}(Component);

var css_248z$8 = '.ct-image-link-modal .content{height:206px!important}.ct-image-link-modal .ant-modal-footer{padding:0 24px 32px;border:none}.ct-image-link-modal .ant-btn{width:60px!important;height:32px;padding:0;margin-left:16px;border-radius:2px}.ct-image-link-modal .input-error{position:absolute;top:55px;left:65px;font-size:12px;color:#e75252}.image-link-content{padding:14px 0;position:relative;font-size:12px;color:rgba(0,0,0,.65)}.image-link-content .ct-image-link-modal-item{color:rgba(0,0,0,.6);line-height:22px}.image-link-content label{display:flex;align-items:center}.image-link-content span{color:rgba(0,0,0,.6);width:60px}.image-link-content input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.image-link-content input[type=text]:focus{border:1px solid #1c6cdc}.image-link-content input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type="text"]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type="text"]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content input[type=text]::placeholder{color:rgba(0,0,0,.24)}';
styleInject(css_248z$8);

/* eslint-disable jsx-a11y/label-has-associated-control */ function _assertThisInitialized$5(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$8(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$5(o) {
    _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$5(o);
}
function _inherits$5(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$5(subClass, superClass);
}
function _possibleConstructorReturn$5(self, call) {
    if (call && (_typeof$5(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$5(self);
}
function _setPrototypeOf$5(o, p) {
    _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$5(o, p);
}
var _typeof$5 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$5() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$5(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$5(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$5(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$5(this, result);
    };
}
var formatLink = function(href) {
    var regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
    var regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
    var newHref = href.replace(regex1, function(match, capture) {
        return capture ? match : "http://".concat(match);
    }) // eslint-disable-line
    ;
    return regex2.test(newHref) ? newHref : false;
};
var LinkModal = /*#__PURE__*/ function(Component) {
    _inherits$5(LinkModal, Component);
    var _super = _createSuper$5(LinkModal);
    function LinkModal(props) {
        _classCallCheck$8(this, LinkModal);
        var _this;
        _this = _super.call(this, props);
        _this.link = "";
        _this.state = {
            error: null
        };
        _this.handleKeydown = function(e) {
            // ENTER
            if (e.which === 13 || e.keyCode === 13) {
                _this.handleOk();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
            return undefined;
        };
        _this.handleInputHref = function(e) {
            var error = _this.state.error;
            if (error) {
                _this.setState({
                    error: null
                });
            }
            _this.link = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, "");
        };
        _this.handleOk = function() {
            var addImageLink = _this.props.addImageLink;
            var link = formatLink(_this.link);
            if (!link) {
                _this.setState({
                    error: i18nClient.t("right_address_tip", "请输入正确的地址")
                });
                return;
            }
            addImageLink(link);
            _this.handleCancel();
        };
        _this.handleCancel = function() {
            var error = _this.state.error;
            var closeModal = _this.props.closeModal;
            if (error) _this.setState({
                error: null
            });
            closeModal();
        };
        _this.link = props.link || "";
        return _this;
    }
    var _proto = LinkModal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener("keydown", this.handleKeydown);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeydown);
    };
    _proto.render = function render() {
        var _this_props = this.props, _this_props_link = _this_props.link, link = _this_props_link === void 0 ? "" : _this_props_link;
        var error = this.state.error;
        return /*#__PURE__*/ React.createElement(Modal, {
            className: classNamePrefix("image-link-modal"),
            title: i18nClient.t("image_link", "图片链接"),
            okText: i18nClient.t("pk_insert", "插入"),
            onOk: this.handleOk,
            onCancel: this.handleCancel,
            canEnter: true
        }, /*#__PURE__*/ React.createElement("div", {
            className: "image-link-content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("image-link-modal-item")
        }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", null, i18nClient.t("pk_link_address", "链接地址")), /*#__PURE__*/ React.createElement("input", {
            id: "imagelink",
            type: "text",
            className: "".concat(classNamePrefix("input"), " input-link-href"),
            placeholder: i18nClient.t("pk_link_address_tip", "请输入链接地址"),
            autoComplete: "off",
            defaultValue: link,
            onInput: this.handleInputHref
        }))), error && /*#__PURE__*/ React.createElement("div", {
            className: "input-error"
        }, error)));
    };
    return LinkModal;
}(Component);

var css_248z$9 = ".ct-image-toolbar.ct-base-toolbar{width:auto;min-width:100px;pointer-events:all;caret-color:#333}.ct-image-toolbar .pm-image-width-label{height:18px;padding-left:8px;margin-top:0;color:#333;font-size:12px;line-height:20px}.ct-image-toolbar .pm-image-width-input{border-radius:2px;border:1px solid #ddd;box-sizing:border-box;width:66px;height:24px;padding:5px 8px 3px;margin:0 0 0 8px;font-size:12px;color:#333;-moz-appearance:textfield}.ct-image-toolbar .pm-image-width-input::-webkit-inner-spin-button,.ct-image-toolbar .pm-image-width-input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0}";
styleInject(css_248z$9);

/* eslint-disable jsx-a11y/label-has-associated-control */ function _assertThisInitialized$6(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$9(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$6(o) {
    _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$6(o);
}
function _inherits$6(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$6(subClass, superClass);
}
function _possibleConstructorReturn$6(self, call) {
    if (call && (_typeof$6(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$6(self);
}
function _setPrototypeOf$6(o, p) {
    _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$6(o, p);
}
var _typeof$6 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$6() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$6(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$6(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$6(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$6(this, result);
    };
}
var ImgToolbar = /*#__PURE__*/ function(Component) {
    _inherits$6(ImgToolbar, Component);
    var _super = _createSuper$6(ImgToolbar);
    function ImgToolbar(props) {
        _classCallCheck$9(this, ImgToolbar);
        var _this;
        _this = _super.call(this, props);
        _this.container = null;
        _this.input = null;
        _this.handleCheckboxChange = function(e) {
            e.stopPropagation();
            e.preventDefault();
            var hasBorder = _this.state.hasBorder;
            var toggleBorder = _this.props.toggleBorder;
            var newHasBorder = !hasBorder;
            _this.setState({
                hasBorder: newHasBorder
            });
            toggleBorder(newHasBorder);
        };
        _this.addLink = function() {
            _this.setState({
                visible: true
            });
        };
        _this.editLink = function() {
            _this.setState({
                visible: true
            });
        };
        _this.cancelLink = function() {
            var cancelImageLink = _this.props.cancelImageLink;
            cancelImageLink();
            _this.setState({
                link: null
            });
        };
        _this.setLink = function(link) {
            var addImageLink = _this.props.addImageLink;
            addImageLink(link);
            _this.setState({
                link: link
            });
        };
        _this.closeModal = function() {
            _this.setState({
                visible: false
            });
        };
        _this.handleInputChange = function(e) {
            var width = e.target.value;
            _this.setState({
                width: width
            });
        };
        _this.setWidth = function() {
            var _this_state = _this.state, oldWidth = _this_state.width;
            var _this_props = _this.props, maxWidth = _this_props.maxWidth, naturalWidth = _this_props.naturalWidth, setWidth = _this_props.setWidth;
            var width = _this.input.value;
            if (width < MIN_IMG_SIZE) {
                if (naturalWidth < 5 || naturalWidth > MIN_IMG_SIZE) {
                    width = MIN_IMG_SIZE;
                } else if (width < naturalWidth) {
                    width = naturalWidth;
                }
            } else if (width > maxWidth) {
                width = maxWidth;
            }
            setWidth(+width);
            if (width !== oldWidth) {
                _this.setState({
                    width: width
                });
            }
        };
        _this.state = {
            hasBorder: props.hasBorder,
            link: props.link,
            visible: false,
            width: "".concat(props.width)
        };
        return _this;
    }
    var _proto = ImgToolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, hasBorder = _this_state.hasBorder, visible = _this_state.visible, width = _this_state.width, link = _this_state.link;
        var hasLink = !!link;
        var linkTool = hasLink ? [
            {
                title: i18nClient.t("pk_cancel_link", "取消链接"),
                icon: "cancelLink",
                callback: this.cancelLink
            },
            {
                title: i18nClient.t("pk_edit_link", "编辑链接"),
                icon: "edit",
                callback: this.editLink
            }
        ] : [
            {
                title: i18nClient.t("pk_link", "链接"),
                icon: "link",
                callback: this.addLink
            }
        ];
        var tools = [
            [
                {
                    custom: /*#__PURE__*/ React.createElement(CheckBox, {
                        key: "border",
                        checked: hasBorder,
                        onChange: function() {},
                        onClick: this.handleCheckboxChange
                    }, i18nClient.t("border", "边框"))
                }
            ],
            linkTool,
            [
                {
                    custom: /*#__PURE__*/ React.createElement(Fragment, {
                        key: "width"
                    }, /*#__PURE__*/ React.createElement("label", {
                        id: "pm-image-width-label",
                        className: "pm-image-width-label",
                        htmlFor: "pm-image-width-input"
                    }, i18nClient.t("width", "宽度")), /*#__PURE__*/ React.createElement("input", {
                        id: "pm-image-width-input",
                        ref: function(i) {
                            _this.input = i;
                        },
                        className: "".concat(classNamePrefix("input"), " pm-image-width-input"),
                        type: "number",
                        autoComplete: "off",
                        value: parseInt(width, 10),
                        onChange: this.handleInputChange,
                        onBlur: this.setWidth,
                        onKeyDown: function(e) {
                            if (e.keyCode === KEY_CODE_ENTER) {
                                // 按回车键可确定输入内容生效
                                e.target.blur();
                                e.stopPropagation();
                                e.preventDefault();
                                return false;
                            }
                            return undefined;
                        }
                    }))
                }
            ]
        ];
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Toolbar, {
            className: "".concat(classNamePrefix("base-toolbar"), " ").concat(classNamePrefix("image-toolbar")),
            tools: tools
        }), visible && /*#__PURE__*/ React.createElement(LinkModal, {
            link: link,
            addImageLink: this.setLink,
            closeModal: this.closeModal
        }));
    };
    return ImgToolbar;
}(Component);

function _assertThisInitialized$7(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$a(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf$7(o) {
    _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$7(o);
}
function _inherits$7(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$7(subClass, superClass);
}
function _possibleConstructorReturn$7(self, call) {
    if (call && (_typeof$7(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$7(self);
}
function _setPrototypeOf$7(o, p) {
    _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$7(o, p);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf$7(object);
        if (object === null) break;
    }
    return object;
}
var _typeof$7 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$7() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$7(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$7(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$7(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$7(this, result);
    };
}
var ToolbarPopover = /*#__PURE__*/ function(PluginView) {
    _inherits$7(ToolbarPopover, PluginView);
    var _super = _createSuper$7(ToolbarPopover);
    function ToolbarPopover(view, config) {
        _classCallCheck$a(this, ToolbarPopover);
        var _this;
        _this = _super.call(this, view, config);
        /**
   * 获取当前选区位置
   */ _this.getPos = function() {
            var state = _this.view.state;
            return state.selection.from;
        };
        _this.getDom = function() {
            return _this.view.nodeDOM(_this.getPos());
        };
        _this.setImageAttr = function(data) {
            var _$view = _assertThisInitialized$7(_this).view;
            var pos = _this.getPos();
            // TODO: 这一块先通过sessionStorage实现，后续考虑通过Provider获取到。
            if (typeof data.border === "boolean") {
                sessionStorage.setItem(IMAGE_BORDER_KEY, data.border ? "1" : "0");
            }
            updateAttrs(data, pos)(_this.view);
            _$view.dispatch(_$view.state.tr.setSelection(NodeSelection.create(_$view.state.doc, _this.getPos())));
            _$view.focus();
        };
        _this.store = config.store;
        return _this;
    }
    var _proto = ToolbarPopover.prototype;
    _proto.show = function show() {
        _get(_getPrototypeOf$7(ToolbarPopover.prototype), "show", this).call(this);
        this.store.popContainer = this.getPopover();
    };
    _proto.destroy = function destroy() {
        _get(_getPrototypeOf$7(ToolbarPopover.prototype), "destroy", this).call(this);
        this.store = null;
    };
    _proto.getNode = function getNode(view) {
        var state = view.state;
        if (state.selection.empty) {
            return null;
        }
        var pos = state.selection.from;
        var selectedNode = state.doc.nodeAt(pos);
        if (!selectedNode || selectedNode.type !== state.schema.nodes.image) {
            return null;
        }
        return view.nodeDOM(pos);
    };
    _proto.getContent = function getContent() {
        var _this = this;
        var state = this.view.state;
        var dom = this.getDom();
        var pos = state.selection.from;
        var node = state.doc.nodeAt(pos);
        if (!node) {
            return null;
        }
        var maxWidth = IMAGE_DEFAULT_WIDTH;
        var naturalWidth = IMAGE_DEFAULT_WIDTH;
        var img = dom.querySelector("img");
        if (img) {
            maxWidth = +(getMaxWidth(img) || IMAGE_DEFAULT_MAX_WIDTH);
            naturalWidth = +(img.getAttribute("data-naturalwidth") || IMAGE_DEFAULT_WIDTH);
        }
        var _node_attrs = node.attrs, border = _node_attrs.border, link = _node_attrs.link, width = _node_attrs.width;
        var _width = Math.min(maxWidth, width || IMAGE_DEFAULT_WIDTH);
        return /*#__PURE__*/ React.createElement(ImgToolbar, {
            hasBorder: border,
            link: link,
            width: _width,
            maxWidth: maxWidth,
            naturalWidth: naturalWidth,
            toggleBorder: function(value) {
                _this.setImageAttr({
                    border: value
                });
            },
            setWidth: function(value) {
                _this.setImageAttr({
                    width: value,
                    height: "auto"
                });
            },
            addImageLink: function(value) {
                _this.setImageAttr({
                    link: value
                });
            },
            cancelImageLink: function() {
                _this.setImageAttr({
                    link: null
                });
            }
        });
    };
    return ToolbarPopover;
}(PluginView);

var css_248z$a = '.ct-editor-container .ProseMirror-selectednode .ct-image,.ct-editor-container .ProseMirror-selectednode .ct-image.ct-image-border{outline:2px solid #0082a6}.ct-editor-container .ct-image.ProseMirror-widget{top:unset}.ct-editor-container .ct-image.ProseMirror-widget img{max-width:100%;min-width:72px;min-height:87px}.ct-editor-container .ct-image.ProseMirror-widget[data-type=ct-progress]{margin:0 3px}.ct-editor-container .ct-image.ProseMirror-widget.selected[data-type=ct-progress]{outline:1px solid #1c6cdc}.ct-editor-container .ct-image{margin:0 3px;display:inline-block;position:relative;max-width:100%;line-height:1;font-size:0;box-sizing:content-box;background-color:#fff;vertical-align:bottom;-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.ct-editor-container .ct-image .ct-image-mask{position:absolute;top:-1px;left:-1px;bottom:-1px;right:-1px;font-size:14px;line-height:20px;overflow:hidden;background:rgba(0,0,0,.7);color:#fff;min-width:72px;min-height:87px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-image .ct-image-mask .ct-image-loading-icon{position:absolute;top:18px;left:22px;width:28px;height:28px;background:url("data:image/svg+xml,%3Csvg width%3D%2232%22 height%3D%2232%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cstyle%2F%3E%3C%2Fdefs%3E%3Cpath d%3D%22M6.572 6.572A13.291 13.291 0 0 1 16 2.667c7.364 0 13.333 5.969 13.333 13.333a13.291 13.291 0 0 1-3.905 9.428l-1.414-1.414A11.298 11.298 0 0 0 27.334 16c0-6.26-5.075-11.333-11.334-11.333a11.298 11.298 0 0 0-8.013 3.32L6.57 6.57z%22 fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E") no-repeat 0;background-size:contain;vertical-align:-8%;-webkit-animation:image-loading .8s linear infinite;animation:image-loading .8s linear infinite}.ct-editor-container .ct-image .ct-image-mask .ct-image-progress-text{position:absolute;top:50px;left:16px;width:40px;text-align:center;text-decoration:none!important}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container{display:none;height:0}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-icon{position:absolute;top:18px;left:22px;width:28px;height:28px;background:url("data:image/svg+xml,%3Csvg width%3D%2232%22 height%3D%2232%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cstyle%2F%3E%3C%2Fdefs%3E%3Cpath d%3D%22M25.849 20.103l1.846.77C25.786 25.45 21.27 28.667 16 28.667 9.005 28.667 3.333 22.995 3.333 16S9.005 3.333 16 3.333c3.41 0 6.507 1.348 8.783 3.54l2.207-2.206 1.886 7.542-7.543-1.886 2.036-2.035A10.63 10.63 0 0 0 16 5.333C10.109 5.333 5.333 10.11 5.333 16S10.11 26.667 16 26.667a10.67 10.67 0 0 0 9.849-6.564zM26.667 16h2-2z%22 fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E") no-repeat 0;background-size:contain}.ct-editor-container .ct-image .ct-image-mask .ct-image-reupload-container .ct-image-reupload-btn{display:block;color:#000}.ct-editor-container .ct-image .ct-image-mask.upload-failed{white-space:normal}.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-loading-icon,.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-progress-text{display:none}.ct-editor-container .ct-image .ct-image-mask.upload-failed .ct-image-reupload-container{margin:10px 5px;display:block}.ct-editor-container .ct-image .image-empty{width:360px;height:100px}.ct-editor-container .ct-image.ct-image-border{display:inline-block;outline:2px solid #ddd}@-webkit-keyframes image-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes image-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}';
styleInject(css_248z$a);

function _assertThisInitialized$8(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck$b(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$8(o) {
    _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$8(o);
}
function _inherits$8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$8(subClass, superClass);
}
function _possibleConstructorReturn$8(self, call) {
    if (call && (_typeof$8(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$8(self);
}
function _setPrototypeOf$8(o, p) {
    _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$8(o, p);
}
var _typeof$8 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$8() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$8(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$8(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$8(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$8(this, result);
    };
}
var __generator$2 = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var IMG_PREFIX = classNamePrefix("image");
var ImageExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$8(ImageExtension, NodeExtension);
    var _super = _createSuper$8(ImageExtension);
    function ImageExtension() {
        _classCallCheck$b(this, ImageExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.store = {} // 用于 plugin view  和 content view 之间的数据交换，暂时没有通用机制
        ;
        _this.nodeViews = ImageNodeView({
            store: _this.store
        });
        return _this;
    }
    var _proto = ImageExtension.prototype;
    _proto.plugin = function plugin(param) {
        var providers = param.providers;
        var _this = this;
        return new Plugin(UploaderOption({
            key: pluginKey,
            props: {
                handleClick: function(view, pos, e) {
                    // 将已经选中的上传中元素取消选中
                    var preSelected = document.querySelector(".".concat(IMG_PREFIX, '[data-type="ct-progress"].selected'));
                    if (preSelected) {
                        preSelected.classList.remove("selected");
                    }
                    // 选中上传中的元素
                    var target = e.target;
                    var uploadingNode = target.closest(".".concat(IMG_PREFIX, '[data-type="ct-progress"]'));
                    if (uploadingNode) {
                        var state = view.state, dispatch = view.dispatch;
                        var selection = TextSelection.create(state.doc, pos, pos + 1);
                        dispatch(state.tr.setSelection(selection));
                        uploadingNode.classList.add("selected");
                        return true;
                    }
                    return false;
                }
            },
            view: function(view) {
                return new ToolbarPopover(view, {
                    className: classNamePrefix("image-toobar-wrapper"),
                    isSticky: true,
                    store: _this.store
                });
            }
        }, {
            createUploadMask: createUploadMask
        }));
    };
    _proto.commands = function commands(param) {
        var providers = param.providers;
        var _this = this;
        return {
            isImageDisabled: isCommonDisabled,
            upload: function(files) {
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    var selectedFiles = files ? Promise.resolve(files) : selectFile({
                        accept: "image/*",
                        multiple: true
                    });
                    selectedFiles.then(function() {
                        var _ref = _asyncToGenerator$2(function(fileList) {
                            var _tmp, i;
                            return __generator$2(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = provider.onSelectFiles;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            provider.onSelectFiles(fileList)
                                        ];
                                    case 1:
                                        _tmp = !_state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (_tmp) {
                                            return [
                                                2
                                            ];
                                        }
                                        for(i = 0; i < fileList.length; i++){
                                            onUpload(view, provider)(fileList[i]);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(fileList) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return true;
                };
            },
            // 在指定位置插入图片，用于数据清洗功能
            insert: function(param) {
                var customUpload = param.customUpload, pos = param.pos;
                return function(state, dispatch, view) {
                    var provider = providers.get(_this.name);
                    onUpload(view, provider, pos)(customUpload);
                    return true;
                };
            },
            updateAttributes: function(data, pos) {
                return function(_, __, view) {
                    pos = pos !== null && pos !== void 0 ? pos : view.state.selection.from;
                    // TODO: 这一块先通过sessionStorage实现，后续考虑通过Provider获取到。
                    if (typeof data.border === "boolean") {
                        sessionStorage.setItem(IMAGE_BORDER_KEY, data.border ? "1" : "0");
                    }
                    var res = updateAttrs(data, pos)(view);
                    view.dispatch(view.state.tr.setSelection(NodeSelection.create(view.state.doc, pos)));
                    view.focus();
                    return res;
                };
            }
        };
    };
    _createClass(ImageExtension, [
        {
            key: "name",
            get: function get() {
                return "image";
            }
        }
    ]);
    return ImageExtension;
}(NodeExtension);

export { ImageExtension };
//# sourceMappingURL=index.js.map
